export default {
    admin: {
        title: 'administrer',
        superadmin: {
            title: 'super administrateur',
            edit: 'modifier'
        },
        invite: {
            manage: 'inviter les ambassadeurs de la communauté',
            resend: 'revivre',
            resend_success: 'L\'invitation a été ressentie',
        },
        events: {
            edit: {
                singular: 'Modifier l\'événement',
                plural: 'Modifier les événements',
            },
            overview: 'événements',
        },
        organizations: {
            edit: {
                singular: 'Modifier l\'organisation et la marque',
                plural: 'Modifier les organisations et les marques',
            },
            overview: 'organisations et marques',
        },
        pages: {
            edit: {
                singular: 'Page de modification',
                plural: 'Modifier les pages',
            },
            update: {
                success: 'page mise à jour',
                singular: "page de mise à jour",
                title: "titre",
                content: "contenu",
                update_success: "page mise à jour avec succès"
            },
            overview: 'pages',
            title: 'titre',
            content: 'contenu',
        },
        prices: {
            update: {
                success: 'Prix \\u200b\\u200bmis à jour',
                singular: "mettre à jour les prix",
                title: "titre",
                content: "contenu",
                update_success: "Prix \\u200b\\u200bmis à jour avec succès"
            },
            success: 'acheter réussi',
        },
        users: {
            edit: {
                singular: 'Modifier l\'utilisateur',
                plural: 'Modifier les utilisateurs',
            },
            active: 'Actif',
            passive: 'Passif',
            overview: 'utilisatrices',
            impersonate: {
                button: 'Usurper l\'identité',
                loading: 'Chargement...',
                error: 'Impossible d\'usurper l\'identité de cet utilisateur.',
            },
        },
        // LA-194: the links Admin hands out so an organiser can submit
        // an event without having an account.
        submission_links: {
            title: 'Liens de soumission',
            intro: 'Liens permettant aux organisateurs de proposer un événement sans compte.',
            new: 'Nouveau lien',
            new_hint: 'Crée un lien à donner à un organisateur par WhatsApp ou e-mail.',
            create: 'Créer le lien',
            created: 'Lien créé',
            search: 'Rechercher',
            copy: 'Copier le lien',
            withdraw: 'Retirer',
            reactivate: 'Réactiver',
            no_brand: 'Pas encore de marque',
            empty: 'Pas encore de liens.',
            failed: 'Une erreur s\'est produite.',
            has_submissions: 'Des propositions sont arrivées par ce lien ; retire-le au lieu de le supprimer.',
            delete_confirm: 'Supprimer le lien {code} ?',
            fields: {
                code: 'Code',
                label: 'Description',
                label_placeholder: 'p. ex. Salsa Nights Rotterdam',
                brand: 'Marque',
                brand_placeholder: 'Chercher une marque',
                brand_hint: 'Facultatif. Détermine la marque à laquelle appartient la proposition.',
                state: 'État',
                submissions: 'Propositions',
                expires_at: 'Expire le',
                max_submissions: 'Max. propositions',
                contact_name: 'Contact',
                contact_email: 'Adresse e-mail',
            },
            states: {
                all: 'Tous',
                active: 'Actif',
                expired: 'Expiré',
                withdrawn: 'Retiré',
                full: 'Complet',
            },
        },
        scraped_concepts: {
            title: 'Scraped Concepts', overview: 'Concepts Overview', edit: { title: 'Edit Concept' },
            columns: { source: 'Source', name: 'Name', dates: 'Dates', location: 'Location', organization: 'Organization', status: 'Status', brand_match: 'Marque', actions: 'Actions' },
            filters: { name: 'Event name', source: 'Source', status: 'Status', city: 'City', date_from: 'Date from', date_to: 'Date to', brand_status: 'Statut de la marque' },

            brand_status: {
                unchecked: 'Pas encore vérifié',
                unmatched: 'Pas encore sur LatinMap',
                unmanaged: 'Existe, non gérée',
                review: 'À vérifier',
                managed: 'Gérée',
            },
            match_signal: {
                email: 'trouvée par e-mail',
                domain: 'trouvée par site web',
                name: 'trouvée par nom',
                name_city: 'trouvée par nom + ville',
                fuzzy: 'nom similaire — à vérifier',
            },
            unlink_brand: 'Délier la marque',
            organization_unlinked: 'Marque déliée',
            unlink_confirm: {
                title: 'Délier la marque ?',
                submit: 'Oui, délier',
                body: 'Supprimer le lien entre « {event} » et la marque « {brand} » ?',
                note: 'Le concept reste dans la liste et peut être lié à une autre marque. Rien n\'est supprimé.',
            },
            link_confirm: {
                title: 'Lier la marque ?',
                submit: 'Oui, lier',
                body: 'Lier « {event} » à la marque « {brand} » ? L\'événement devra encore être approuvé séparément.',
                signal: 'Trouvé :',
                warning_managed: 'Cette marque est gérée activement par un Professional. Lier un événement collecté peut entrer en conflit avec son travail.',
                warning_review: 'Cette correspondance n\'est pas sûre. Vérifiez qu\'il s\'agit bien de la même marque avant de lier.',
            },
            link_match: 'Lier cette marque',
            refresh_matches: 'Actualiser les correspondances',
            refresh_matches_help: 'Recalculer à quelles marques existantes appartiennent les organisateurs collectés',
            matches_refreshed: 'Correspondances actualisées : {certain} sûres, {possible} à vérifier',
            bulk: {
                selected: '{count} sélectionné(s)',
                link_matched: 'Lier la marque trouvée',
                approve: 'Approuver',
                reject: 'Rejeter',
                clear: 'Effacer la sélection',
                running: 'En cours...',
                select_all: 'Tout sélectionner sur cette page',
                select_one: 'Sélectionner {name}',
                nothing_to_link: 'Aucune correspondance sûre dans la sélection',
                nothing_to_unlink: 'Aucune marque liée dans la sélection',
                unlink: 'Délier',
                result: '{succeeded} traités, {failed} ignorés',
                confirm: {
                    title: 'Confirmer l\'action groupée',
                    submit: 'Oui, continuer',
                    body_approve: 'Publier {count} concept(s) ? Ceux sans marque confirmée ou sûre sont ignorés.',
                    body_reject: 'Rejeter {count} concept(s) ?',
                    body_unlink: 'Supprimer le lien de marque de {count} concept(s) ?',
                    unlink_skipped: '{skipped} de la sélection sont ignorés : aucune marque liée.',
                    body_assign: 'Lier {count} concept(s) à leur marque trouvée ? Les événements devront encore être approuvés séparément.',
                    assign_skipped: '{skipped} de la sélection sont ignorés : déjà liés ou sans correspondance sûre.',
                    and_more: 'et {count} de plus',
                    assign_managed: '{count} de ces marques sont gérées activement par un Professional. Lier peut entrer en conflit avec leur travail.',
                },
            },
            status_labels: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected' },
            no_organization: 'No organization assigned', no_results: 'No concepts found', assign_first: 'Please assign an organization first',
            assign_organization: 'Assign Organization', search_organization: 'Search organization by name', current_organization: 'Currently assigned',
            organization_assigned: 'Organization assigned successfully', approve: 'Approve', reject: 'Reject',
            approved_success: 'Concept approved and event created', rejected_success: 'Concept rejected', approve_error: 'Failed to approve',
            save_success: 'Concept saved', scraped_at: 'Scraped at', view_source: 'View source', photos: 'Photos', admin_notes: 'Admin notes',
            reject_confirm: { title: 'Reject Concept', body: 'Are you sure you want to reject this concept?', submit: 'Reject' },
            search_btn: 'Search',
            back: 'Back',
            missing_fields: 'Please fill in the required fields',
            scraping: 'Scraping',
            scrape_result: 'Fetched {fetched}, created {created}, skipped {skipped}, errors {errors}',
        },
        report: {
            details: 'détails:',
            reported: 'rapporté par:',
            suspended_at: 'suspendu à:',
            email: 'e-mail:',
            phonenumber: 'numéro de téléphone',
            message: 'message:',
            singular: 'rapport',
            plural: 'rapports',
            reportables: {
                event: 'événements',
                organization: 'organisations',
            },
            status: {
                submitted: 'Soumise',
                under_review: 'En cours d\'examen',
                resolved: 'Résolue',
                no_issue: 'Aucun problème',
            },
            reportables_by_type: {
                event: 'événement',
                organisation: 'organisations et marques',
                user: "utilisatrice",
                created_by: 'créé par',
                report_by: 'signaler',
                ip_adress: 'IP-ADRESS',
                reason: 'raison',
                description: 'description',
                empty: 'vide',
            },
            no_reports: 'Aucun rapport trouvé',
        },
        lead: {
            singular: 'plomb',
            plural: {
                event: 'L\'événement',
                organization: 'marque'
            }
        },
        block_user: {
            plural: 'bloquer les utilisateurs',

            title: 'bloquée',
            description: 'Your account has been blocked, you don\'t have access to the platform anymore.'
        },
        setting: {
            plural: 'paramètres',
            reset: {
                warning: {
                    title: 'Réinitialisez tous les paramètres de l\'administrateur.',
                    body: 'Êtes-vous sûr de vouloir réinitialiser tous les paramètres?'
                }
            }
        },
        permissions: {
            plural: 'autorisation',
            levels: {
                'level-1': 'super administrateur',
                'level-2': 'administrer',
                'level-3': 'ambassadrice',
                'level-4': 'membre haut de gamme',
                'level-5': 'membre professionnel',
                'level-6': 'membre',
            },
            no_users_with_role: 'Il n\'y a pas d\'utilisateurs avec ce niveau de rôle.',
            rights: {
                'create-organization-on-behalf-of-other-user': 'créer une organisation au nom d\'un autre utilisateur',
                'latinmap-verify': 'Accorder le statut vérifié latinmap',
                invite: {
                    'level-3': 'inviter les ambassadeurs de la communauté',
                },
                reports: {
                    view: 'Afficher les rapports',
                    delete: {
                        any: 'Supprimer n\'importe quel rapport',
                    },
                    update: 'mettre à jour l\'état du rapport',
                    export: 'Rapports d\'exportation',
                },
                events: {
                    create: 'créer des événements',
                    view: 'Voir les événements',
                    update: {
                        any: 'Mettre à jour tout événement',
                        own: 'Mettre à jour les propres événements',
                    },
                    delete: {
                        any: 'Supprimer tout événement',
                        own: 'Supprimer ses propres événements',
                    },
                    publish: 'Publier des événements',
                    unpublish: 'événements inébranlables',
                    ownership: {
                        own: 'Changer la propriété des propres événements',
                        any: 'Changer la propriété de tout événement',
                    },
                    ticketshop: {
                        enable: 'Activer TicketShop',
                    },
                },
                organisations: {
                    create: 'créer des organisations et des marques',
                    update: {
                        any: 'Mettre à jour toutes les organisations et marques',
                        own: 'Mettre à jour ses propres organisations et marques',
                    },
                    delete: {
                        any: 'Supprimer toutes les organisations et marques',
                        own: 'Supprimer ses propres organisations et marques',
                    },
                    ownership: {
                        own: 'Changer la propriété des propres organisations et marques',
                        any: 'Changer la propriété de toutes les organisations et marques',
                    },
                },
                users: {
                    edit: 'Modifier les utilisateurs',
                },
                leads: {
                    view: 'Afficher les pistes',
                    delete: 'Supprimer les pistes',
                },
                transfer_requests: {
                    view: 'Afficher les demandes de transfert',
                    approve: 'approuver les demandes de transfert',
                }
            }
        },
        dance_styles: {
            title: 'Styles de danse',
            singular: 'style de danse',
            create: {
                singular: 'Créer un style de danse',
            },
            edit: {
                singular: 'Modifier le style de danse',
                plural: 'Modifier les styles de danse',
            },
            delete: {
                title: 'Supprimer le style de danse?',
                singular: 'supprimer',
                cancel: 'Annuler',
                confirmation: 'Ce style de danse a des styles de danse.',
                affected: 'Ce style de danse est utilisé dans les événements {event_count} et les organisations {organisation_count}.',
                label: 'Supprimer le style de danse',
                placeholder: 'Tapez {keyword} ici et soumettez pour supprimer ce style de danse.',
            },
            sub_dance_style: 'style de danse',
            is_favorite: 'est préféré',
        },
        music_styles: {
            title: 'styles musicaux',
            singular: 'style musical',
            create: {
                singular: 'Créer un style musical',
            },
            edit: {
                singular: 'Modifier le style musical',
                plural: 'Modifier les styles de musique',
            },
            delete: {
                title: 'supprimer le style de musique?',
                singular: 'supprimer',
                cancel: 'Annuler',
                confirmation: 'Ce style musical a des styles de musique.',
                affected: 'Ce style musical est utilisé dans les organisations {event_count} et {organisation_count}.',
                label: 'Supprimer le style de musique',
                placeholder: 'Tapez {keyword} ici et soumettez pour supprimer ce style de musique.',
                substyles: 'Ce style musical a des styles sous-musiques.',
            },
            sub_dance_style: 'style de danse',
            sub_music_style: 'style de musique',
            is_favorite: 'est préféré',
        },
        featuredEvent: 'événement en vedette',
        event_types: {
            edit: {
                plural: 'Modifier les types d\'événements',
            }
        },
        brand_types: {
            edit: {
                plural: 'Modifier les types de marque',
            }
        },
        prof_financial_title: 'place financière',
        modoration:
        {
            title: 'modération',
        },
        official_brands: 'offical brands',
        export: {
            overview: {
                title: 'exportation et transferts',
                subtitle: 'Exporter toutes les organisations, un lien de transfert sera généré pour chaque organisation.'
            },
            create: 'Créer des exportations',
            copied_link: 'lien copié',
            take_ownership: 'Take ownership',
            validate_phone: 'Afin de s\'approprier cette organisation, vous devez d\'abord valider votre numéro de téléphone, cela peut être fait ci-dessous ici:',
            require_login: 'Afin de s\'approprier cette organisation, vous devez d\'abord vous connecter ou créer un compte, cela peut être fait ci-dessous ici:',
            to_login: 'se connecter',
            messages: {
                opened: 'Votre lien de transfert a été activée avec succès, vous avez 30 jours pour terminer le processus.',
                continue: 'Votre lien de transfert a été rouvert avec succès, veuillez terminer le processus de transfert.',
                no_key: 'Aucune clé n\'a été fournie, cela peut se produire si vous actumiez la page, vous devez ouvrir à nouveau le lien d\'origine.',
                not_exists: 'There currently is no transfer link for this organization.',
                unauthorized: "Vous n'êtes pas autorisé à accepter ce transfert d'organisation.",
                expired: 'This link has expired. Contact LatinMap to receive a new transfer link.',
                already_completed: 'Ce lien est déjà terminé et ne peut plus être utilisé.',
                transferred: 'L\'organisation a été transférée avec succès.'
            },
            warning: {
                title: 'Supprimer la liaison de transfert',
                body: 'Êtes-vous sûr de vouloir supprimer ce lien de transfert?'
            },
            status: {
                no_action: 'non transféré',
                opened: 'ouverte',
                completed: 'transféré',
                expired: 'expiré'
            }
        },
        duplications: 'duplications',
        suspend_toggle: {
            warning: {
                title: 'suspension à bascule',
                body: 'Êtes-vous sûr de vouloir changer la suspension de cela?'
            }
        },
        take_offline: {
            warning: {
                title: 'décoller',
                body: 'Êtes-vous sûr de vouloir prendre cette ligne hors ligne, il ne sera plus visible pour les utilisateurs.'
            }
        },
        bring_online: {
            warning: {
                title: 'Mettre en ligne',
                body: 'Êtes-vous sûr de vouloir mettre cela en ligne? Cela sera visible pour les utilisateurs.'
            }
        },
        'carousel-image': {
            plural: "Images du carrousel",
            overview: {
                title: "Images du carrousel",
                subtitle: "Gérez les images du carrousel sur la page d'accueil."
            },
            create: {
                singular: "Créer une image du carrousel",
                success: "Image du carrousel créée avec succès",
                error: "Erreur lors de la création de l'image du carrousel"
            },
            delete: {
                success: "Image du carrousel supprimée avec succès",
                error: "Erreur lors de la suppression de l'image du carrousel"
            },
            image: "Image",
            visibility: 'secondes visibles',
            title: "Titre",
            order_by: "Trier par",
            warning: {
                body: "Êtes-vous sûr de vouloir supprimer cette image du carrousel ? Cette action est irréversible.",
                title: "Supprimer l'image du carrousel"
            },
        },
        'beta-feature': {
            plural: 'Fonctionnalités bêta',
            overview: {
                title: 'Fonctionnalités bêta',
                subtitle: 'Gérez les fonctionnalités bêta sur la plateforme.',
                success: 'Fonctionnalité bêta activée avec succès',
                error: 'Erreur lors de l\'activation de la fonctionnalité bêta',
            },
            key: 'Clé',
            name: 'Nom',
            description: 'Description',
            visible_to_admins: 'Visible aux administrateurs',
            visible_to_users: 'Visible aux utilisateurs',
        }
    },
    nav_headers: {
        agenda: {
            label: 'Agenda Latin',
            options: {
                all_events: 'Tous les Événements',
                latin_festivals_and_congresses: 'Festivals Latin et Congrès',
                latin_parties_and_socials: 'Parties Latin et Sociaux'
            }
        },
        dance_schools: {
            label: 'Écoles de Danse Latin',
            options: {
                dance_schools: 'Écoles de Danse',
                try_outs_and_start_courses: 'Essayez et Commencez des Cours',
                workshops_and_bootcamps: 'Ateliers et Bootcamps',
                about_the_latin_dance_scene: 'À Propos de la Acène de Danse Latin'
            }
        },
        community: {
            label: 'Communauté Latin',
            options: {
                teachers: 'Enseignantes',
                show_performers_and_teams: 'Spectacles et Équipes',
                djs: 'DJ',
                live_bands: 'Groupes / Musique Live',
                media_photo_video: 'Médias, Photo, Vidéo',
                mcs: 'MC'
            }
        },
        dancewear_and_shoes: {
            label: 'Latin Dancewear et Chaussures',
            options: {
                dancewear_and_shoes: 'Vêtements de Danse et Chaussures'
            }
        },
        for_professionals: {
            label: 'Pour les Professionnels',
            options: {
                create_a_brand: 'Comment Créer une Marque',
                create_an_event: 'Comment Créer un Événement',
                promote_your_event: 'Comment Promouvoir votre Événement',
                professional_account_verification: 'Vérification du Compte Professionnel'
            }
        },
        join: {
            label: 'Rejoindre LatinMap',
            options: {
                create_a_brand_or_organization: 'Créer une Marque ou une Organisation',
                become_an_ambassador: 'Devenir Ambassadeur'
            }
        },
        manage_and_promote: {
            label: 'Gérer et Promouvoir',
            options: {
                my_events: 'Mes Événements',
                promote_your_event: 'Promouvoir votre Événement'
            }
        }
    },
    impersonation: {
        banner: 'Vous consultez en tant que {name}',
        stop: 'Arrêter l\'usurpation',
    },
    menu_headers: {
        general_title: 'générale',
        orders_title: 'Mes commandes',
        settings_title: 'paramètres',
        professional_title: 'professionnelle',
        prof_financial_title: 'Mon centre financier',
        special_access_title: 'accès spécial',
        community_dashboard_title: 'mon ambassadeur du tableau de bord communautaire',
        session_title: 'session',
    },
    account: {
        owned_by_organization: "Détenu par l'organisation {organization_name}",
        organization_settings_title: 'Paramètres de l\'Organisation',
        selected_organization: 'Organisation sélectionnée',
        my_events: 'Mes événements',
        role: 'Rôle',
        dashboard: "tableau de bord",
        default_filters: "Mes recherches",
        login: "se connecter",
        logout: "déconnexion",
        sign_in: "se connecter",
        sign_up: "s\'inscrire",
        email_address: "adresse email",
        password: "mot de passe",
        password_repeat: "Répéter le mot de passe",
        password_reset: "réinitialisation du mot de passe",
        password_forgot: "Mot de passe oublié",
        reset_password: "Réinitialiser le mot de passe",
        current_password: "mot de passe actuel",
        change_password: "changer le mot de passe",
        new_password: "nouveau mot de passe",
        password_reset_success: "réinitialiser le mot de passe réussi",
        forgot_password: "Mot de passe oublié",
        not_a_member: "pas membre",
        i_already_have_an_account: "J\'ai déjà un compte",
        i_accept_the: "J\'accepte le",
        terms_and_conditions: "termes et conditions",
        first_name: "prénom",
        last_name: "nom de famille",
        postal_code: "Code Postal",
        street_number: "numéro de rue",
        city: "ville",
        country: "pays",
        preferred_language: "Langue préférée",
        date_of_birth: "date de naissance",
        create: "créer un compte",
        my_account: "Mon compte",
        my_professional_dashboard: "Mon tableau de bord professionnel",
        ambassador_dashboard: "tableau de bord de l\'ambassadeur",
        my_organisations: "Mes organisations et marques",
        my_organisations_description: "Gérez vos organisations et marques",
        singular: "compte",
        phone: "numéro de téléphone",
        phone_verification_token: "jeton de vérification du téléphone",
        name: "nom",
        user_name: "nom d\'utilisateur",
        resend_verification: "Rendre la vérification",
        update_error: 'La mise à jour de votre compte a échoué.',
        myLatinmap: "Mon LatinMap",
        dancerprofile: "Mon profil de danseurs",
        orders: 'Mes commandes',
        phone_verification: 'vérification du téléphone',
        submitted_leads: 'mes pistes soumises',
        settings: 'paramètres',
        switch: 'Passer à la marque/organisation',
        beta_features: 'Fonctionnalités bêta',
        gender: {
            singular: "genre",
            male: "femelle",
            female: "femelle",
            other: "autre",
        },
        profile: {
            title: 'profil',
            description: 'Gérez vos informations de profil, modifiez votre mot de passe et plus encore.',
        },
        remove: {
            label: 'supprimer le compte',
            placeholder: 'Tapez "delete" ici et soumettez pour supprimer votre compte.',
            admin_placeholder: 'Tapez "delete" ici et soumettez pour supprimer ce compte.',
            safeword: 'supprimer',
            description: 'Cela supprimera votre compte et toutes les données associées.',
        },
        favorites: {
            title: 'favoris',
            description: 'Vos événements préférés, écoles de danse, etc.',
            no_favorites: 'Vous n\'avez pas encore de favoris dans cette catégorie',
            plurals: {
                event: 'événements',
                dancer: 'danseuses',
                dj: 'DJ',
                media: 'médias',
                brand: 'chaussures de danse, vêtements, magasin',
                school: 'écoles de danse',
                venue: 'Lieux',
                club: "club",
                teacher: "professeure",
                show_performers_and_teams: "spectacles et équipes",
                performer: "interprète",
                mc: "MC",
                latin_music: "musique latine",
                event_organizer: "organisateur d\'événements",
                organization: 'organisations et marques',
            },
        },
        likes: {
            title: 'goûts',
            description: 'Vos événements aimé, écoles de danse, etc.',
            no_likes: 'Vous n\'avez pas encore de goûts dans cette catégorie',
            plurals: {
                event: 'événements',
                dancer: 'danseuses',
                dj: 'DJ',
                media: 'Médias (photo, vidéo, montage vidéo)',
                brand: 'chaussures de danse, vêtements, magasin',
                school: 'écoles de danse',
                venue: 'Lieux',
                club: "club",
                teacher: "professeure",
                show_performers_and_teams: "spectacles et équipes",
                performer: "interprète",
                mc: "MC",
                latin_music: "musique latine",
                event_organizer: "organisateur d\'événements",
                organization: 'organisations et marques',
            },
        },
        verification: {
            phone: {
                description: "La vérification du téléphone est nécessaire pour garantir la sécurité et l\'authenticité des utilisateurs qui accédaient au tableau de bord «professionnel».",
                not_verified: 'Votre numéro de téléphone n\'est pas vérifié.',
                send_verification_text: 'Envoyer un texte de vérification',
                sent: 'Texte de vérification envoyé',
                verified: 'Votre numéro de téléphone est vérifié.',
                verify: 'Vérifiez le numéro de téléphone',
            },
        },

    },
    dashboard: {
        title: "tableau de bord",
        welcome: "Bienvenue",
    },
    organizations: {
        organization_saved: 'Organisation sauvée',
        containing_emoji_error: 'Les émojis ne sont pas autorisés dans le nom. Utilisez des caractères alphanumériques ou des caractères spéciaux autorisés.',
        invalid_character_error: 'Le nom contient un caractère non valide. Utilisez des caractères alphanumériques ou des caractères spéciaux autorisés.\nCaractères non valides: ',
        overview: {
            filters: {
                option_labels: {
                    favorites: {
                        all: 'toute',
                    },
                    organization_type: {
                        all: 'toute',
                        dance_schools: 'écoles de danse',
                        organizers: 'organisatrices',
                        artists: 'Enseignants et interprètes',
                        disk_jockeys: 'DJ',
                    }
                }
            },
            no_results: {
                title: 'Aucune organisation trouvée',
                subtitle: 'Aucune organisation trouvée pour les filtres sélectionnés.'
            },
        },
        transfers: {
            overview: {
                title: 'transferts',
                subtitle: 'Gérer la propriété de vos organisations',
                incoming_transfers: 'transferts entrants',
                outgoing_transfers: 'transferts sortants',
                request: 'demande',
                offer: 'offre',
                event: 'événement',
                organization: 'organisation',
            },
            status: {
                approved: 'transfert accepté',
                pending: 'en attente',
                rejected: 'Le transfert a diminué'
            },
            create: {
                title: 'transférer la propriété',
                organization: 'organisation',
                description: 'Transférer la propriété de votre organisation à un autre utilisateur.',
                reason: 'raison',
                transfer_to: 'transférer à (e-mail)',
                transfer: 'transfert',
                warning: 'Dès que le transfert est accepté, la propriété de l\'organisation sera transférée au nouveau propriétaire.',
            }
        },
        remove: {
            label: 'Supprimer l\'Organisation',
            description: 'Supprimer définitivement cette organisation et toutes les données associées.',
            success: 'Organisation supprimée avec succès',
            error: 'Échec de la suppression de l\'organisation'
        },
        transactions: {
            overview: {
                title: 'transactions',
                subtitle: 'Gérer les transactions de vos organisations et marques',
            }
        },
        create: 'créer une organisation',
        is_public_options: {
            private: 'privée',
            public: 'publique',
            private_warning: 'Votre organisation n\'est pas visible en ligne avec ce statut.'
        },
        offline_preview: 'Cette organisation est hors ligne et visible uniquement en aperçu.',
    },
    organization: {
        accepts_posts_on_behalf: 'Autoriser LatinMap à ajouter nos événements',
        accepts_posts_on_behalf_help: 'Quand notre marque est inactive, LatinMap peut ajouter des événements annoncés publiquement en notre nom. Ils sont clairement identifiés et vous pouvez les modifier ou les supprimer à tout moment.',
        'on-behalf-of': 'au nom de',
        'on-behalf': {
            none: 'Sélectionnez votre option',
            me: 'Moi, je représente cette marque',
            other: 'En tant que représentant de la marque',
            noone: 'En tant qu\'ambassadeur de LatinMap',
        },
        featured: {
            title: 'écoles de danse en vedette',
            subtitle: 'Certaines des académies de danse de premier ordre en vedette avec des cours de danse maintenant disponibles.',
        },
        my_favorites: {
            title: 'mes favoris',
        },
        edit: {
            public_information: 'information',
            customers: 'clientes',
            events: 'événements',
            tickets: 'billets',
            authorized_person: 'Personnes autorisées',
        },
        organization_detail: {
            involved: 'impliqué',
            verification_status: {
                verified: 'vérifié',
                not_verified: 'Pas encore vérifié',
            }
        },
        account: {
            title: "compte",
            description: "Gérez les informations de votre compte pour le tableau de bord professionnel.",
            description_not_verified: "Veuillez vérifier le numéro de téléphone afin d\'utiliser le tableau de bord professionnel.",
        },
        transfer: {
            title: 'transférer la propriété',
            description: 'Voulez-vous demander la propriété de cette organisation?',
            what: 'Qu\'est-ce qui est offert?',
            submit: 'soumettre une demande',
            name: 'nom',
            location: 'emplacement',
            email: 'e-mail',
            reason: 'raison',
            organization: 'organisation et marque',
            errors: {
                nameRequired: 'le nom est requis.',
                emailRequired: 'un e-mail est requis.',
                reasonRequired: 'la raison est requise.'
            },
            succesfully_sent: 'La demande de transfert a été envoyée avec succès.',
            error_occurred: 'Quelque chose s\'est mal passé.',
            noOrganisation: 'Vous n\'avez pas encore d\'organisations.'
        },
        title: "organisation",
        is_public: 'est public',
        publicly_visible: 'visible publiquement',
        change_organization: "Organisation de changement",
        create: "créer une organisation",
        name: "nom",
        name_without_dj: "Nom (sans 'dj')",
        dj_name_tooltip: "Entrez uniquement le nom. 'DJ' sera ajouté automatiquement",
        email: "e-mail",
        phone: "numéro de téléphone",
        phone_verification_token: "jeton de vérification du téléphone",
        country: "pays",
        city: "ville",
        street: "rue",
        street_number: "numéro de rue",
        postal_code: "Code Postal",
        type: "taper",
        question: "Votre organisation?",
        types: {
            event: 'Événement',
            dancer: "danseuse",
            latin_music: "musique latine",
            performer: "interprète",
            teacher: "professeure",
            show_performers_and_teams: "spectacles et équipes",
            dj: "DJ",
            mc: "MC",
            media: "Médias (photo, vidéo, montage vidéo)",
            brand: "chaussures de danse, vêtements, magasin",
            event_organizer: "organisateur d\'événements",
            school: "école de danse",
            live_music: "groupe / musique live",
            venue: "lieu",
        },
        short_description: "Brève description",
        long_description: "longue description",
        photos: "photos",
        dance_styles: "Styles de danse",
        music_styles: "styles musicaux",
        my_brands: "Mes marques",
        my_brands_description: "Gérez vos marques",
        overview: {
            title: 'écoles de danse',
            subtitle: 'Trouvez les meilleures écoles de danse de votre région.',
            filters: {
                organization_name: 'nom de l\'organisation',
                dance_styles: 'Styles de danse',
                postal_code: 'Code Postal',
                nearby_range: 'Gamme de suggestions de code postal à proximité',
                nearby: 'Suggestions à proximité',
                location: 'où',
                favorites: 'favoris',
                country_codes: 'codes de pays',
                music_styles: 'styles musicaux',
                ambassadors: 'ambassadrices',
                slidertooltip: '<p> <strong> Le curseur de plage ajuste les chiffres du code postal entré pour agrandir la zone de recherche. </strong> <p> Chaque étape augmente le code postal de 100. </p><p> Par exemple, à',
            },
            organizers: {
                title: 'organisatrices',
                subtitle: 'Trouvez les meilleurs organisateurs de votre région.',
            },
            artists: {
                title: 'Enseignants et interprètes',
                subtitle: 'Trouvez les meilleurs artistes de votre région.',
            },
            dance_schools: {
                title: 'écoles de danse',
                subtitle: 'Trouvez les meilleures écoles de danse de votre région.',
            },
            disk_jockeys: {
                title: 'DJ',
                subtitle: 'Trouvez les meilleurs DJ de votre région. Profitez des meilleurs événements et festivals.',
            },
            show_performers_and_teams: {
                title: 'spectacles et équipes',
                subtitle: 'Trouvez les meilleurs interprètes de votre région.',
            },
            teacher: {
                title: 'enseignantes',
                subtitle: 'Trouvez les meilleurs enseignants de votre région.',
            },
            mcs: {
                title: "MC",
                subtitle: 'Trouvez les meilleurs MC dans votre région.',
            },
            live_music: {
                title: "groupes / musique live",
                subtitle: 'Trouvez les meilleurs groupes et musique live de votre région.',
            },
            live_performer: {
                title: "artiste en direct",
                subtitle: 'Trouvez les meilleurs artistes en direct de votre région.',
            },
            performer: {
                title: "interprète",
                subtitle:
                    "Trouvez les meilleurs artistes live de votre région. Profitez des meilleurs événements et festivals."
            },
            media: {
                title: "Médias (photo, vidéo, montage vidéo)",
                subtitle: 'Trouvez les meilleurs photographes et vidéastes de votre région.',
            },
            brand: {
                title: "chaussures de danse, vêtements, magasin",
                subtitle: 'Trouvez les meilleures chaussures de danse et vêtements de votre région.',
            },
        },
        artists: {
            title: 'Enseignants et interprètes',
        },
        teacher: {
            title: 'enseignantes',
        },
        performer: {
            title: 'interprètes'
        },
        show_performers_and_teams: {
            title: 'spectacles et équipes',
        },
        dance_schools: {
            title: 'écoles de danse',
        },
        disk_jockeys: {
            title: 'DJ',
        },
        organizers: {
            title: 'organisatrices',
        },
        manage_authorized_people: {
            title: 'Gérer les personnes autorisées',
            description: 'Gérez les personnes autorisées des organisations dont vous êtes propriétaire. Les personnes autorisées peuvent gérer votre organisation et vos événements.',
        },
        authorized_people: {
            title: 'Personnes autorisées',
            description: 'Gérer les personnes autorisées de vos organisations. Les personnes autorisées peuvent gérer votre organisation et vos événements.',
            create: 'Créer une personne autorisée',
            edit: 'Modifier la personne autorisée',
            overview: 'Personnes autorisées',
            not_found: 'Aucune personne autorisée trouvée',
        },
        mcs: {
            title: "MC",
        },
        live_music: {
            title: "groupes / musique live",
        },
        live_performer: {
            title: "artistes en direct",
        },
        media: {
            title: "Médias (photo, vidéo, montage vidéo)",
        },
        brand: {
            title: "chaussures de danse, vêtements, magasin",
        },
        email_authorized: 'entrez une adresse e-mail existante.',
    },
    ambassador: {
        profile: "profil",
        my_brands: "Mes marques",
        verification: {
            phone: {
                description: "La vérification du téléphone est nécessaire pour assurer la sécurité et l\'authenticité des utilisateurs qui accédaient au tableau de bord «ambassadeur»."
            }
        }
    },
    brands: {
        create: "créer une marque",
        brand_saved: "Sauvé de marque",
        change_brand: "Changer la marque",
        edit: {
            authorized_person: "Personnes autorisées"
        },
        posted_by_ambassador_text: 'Cette marque a été créée par un ambassadeur LatinMap, un membre de la communauté de confiance contribuant au contenu de la plate-forme.',
    },
    contact: {
        title: "contact",
        name: "nom",
        email: "e-mail",
        message: "message",
        subject: "sujette",
        send: "envoyer",
        success: "Message envoyé",
        error: "Le message n\'a pas pu être envoyé",
    },
    ticketstore: {
        select_amount: 'Sélectionner le montant de la billette',
        your_information: 'Vos informations',
        total: 'totale',
        next: 'suivante',
        back: 'dos',
        checkout: 'vérifier',
        tickets_for: 'billets pour',
        ticket_types: 'types de billets',
        ticket: {
            starts_at: 'commence à',
            location: 'emplacement',
            name: 'nom',
            description: 'description',
            tickets_sold: 'Billets vendus',
            actions: 'actes',
            available: 'disponible',
            total_available: 'Total disponible',
            price: 'prix',
            create: 'Créer un type de billette',
            edit: 'Modifier le type de billette',
            success: 'Votre type de billet a été soumis avec succès.',
            remove_label: 'Supprimer le type de billet',
            remove_description: 'Cela supprimera le type de billet et toutes les données associées.',
        },
    },
    events: {
        select_category: "Sélectionnez une catégorie",
        select_country: "Sélectionnez un pays",
        select_timezone: "Sélectionnez un fuseau horaire",
        select_status: "Sélectionnez un statut",
        select_currency: "Sélectionnez une devise",
        select_brand_error: "Aucune marque sélectionnée",
        title: 'événements',
        bring_online: 'mettre en ligne',
        take_offline: 'mettre hors ligne',
        by: 'événements de {organisation_name}',
        create_new: 'Créer un nouvel événement',
        event_saved: 'Événement enregistré',
        event_published: 'Votre événement est maintenant en direct et visible sur la page des événements.',
        error_saving: 'Événement d\'enregistrement d\'erreur',
        containing_emoji_error: 'Les émojis ne sont pas autorisés dans le nom. Utilisez des caractères alphanumériques ou des caractères spéciaux autorisés.',
        invalid_character_error: 'Le nom contient un caractère non valide. Utilisez des caractères alphanumériques ou des caractères spéciaux autorisés.\nCaractères non valides: ',
        duration_too_long: 'La durée de cet événement est trop longue, le nombre maximum de jours qu\'un événement est autorisé à prendre est: ',
        error_updating_ticket_type: 'Une erreur s\'est produite lors de l\'enregistrement du type de billette.',
        ticket_type_updated: 'Le type de billet a été mis à jour avec succès.',
        posted_by_ambassador: 'Publié par l\'ambassadeur de Latinmap',
        posted_by_ambassador_text: 'Cet événement a été créé par un ambassadeur LatinMap, un membre de la communauté de confiance contribuant au contenu de la plate-forme.',
        posted_on_behalf_text: 'LatinMap a ajouté cet événement à partir d\'informations publiquement disponibles. L\'organisateur n\'a pas encore mis à jour lui-même ces informations.',
        posted_on_behalf_label: 'ajouté par LatinMap',
        // LA-202: the public pill on the event page. Separate from the
        // line above, which is appended to a title in the organiser's own
        // list and reads as a note rather than a credit.
        posted_by_latinmap: 'Publié par LatinMap',
        not_posted_by_ambassador: 'Vérifié par l\'organisateur',
        participants: {
            create: {
                title: 'Créer un participant pour "{event_name}"',
                description: 'Créer un nouveau participant à l\'événement "{event_name}"',
                invite: 'inviter le participant',
                role: 'rôle',
            },
            role: {
                performer: 'interprète',
                organizer: 'organisatrice',
            },
            overview: {
                participants: 'participantes',
            }
        },
        statuses: {
            active: 'active',
            canceled: 'annulé',
            changed: 'modifié',
            pending: 'en attente'
        },
        currencies: {
            none: 'Pas de monnaie',
            euro: 'Euro',
            dollar_american: 'Dollar Américain',
            pound_uk: 'Livre Anglaise',
            lira_turkish: 'Livre Turque',
            rupee_indian: 'Roupie Indienne'
        },
        event_detail: {
            cta_block: {
                title: 'billets',
                subtitle: 'Il y a des billets disponibles pour cet événement!',
                button: 'Obtenez vos billets maintenant'
            },
            organizer: {
                plural: 'organisatrices',
                singular: 'organisatrice',
                invariable: 'organisatrices)',
            }
        },
        overview: {
            title: 'événements',
            nearby_events: 'événements à proximité',
            subtitle: 'Immergez-vous dans les rythmes rythmiques, les mouvements exaltants et la fusion culturelle de la salsa, du bachata et plus encore.',
            festival: {
                title: 'festivals de danse et congrès',
            },
            try_out: {
                title: 'Essayer, journée portes ouvertes, début des cours',
            },
            party_social: {
                title: 'Soirées et Sociales',
            },
            no_results: {
                title: 'Aucun événement trouvé',
                subtitle: 'Aucun événement trouvé pour les filtres sélectionnés.'
            },
            filters: {
                event_name: 'Nom de l\'événement ou de l\'organisation',
                event_id: "ID de l'événement",
                event_category: 'type d\'événement',
                dance_styles: 'Styles de danse',
                dance_style: 'style de danse',
                music_styles: 'styles musicaux',
                music_style: 'style musical',
                ambassadors: 'ambassadrices',
                status: 'statut',
                user_name: 'utilisatrice',
                user_type: 'type d\'utilisateur',
                organization: 'organisation',
                organization_type: 'Type d\'organisation',
                location: 'où',
                date: 'quand',
                date_from: 'depuis',
                date_to: 'à',
                apply_filters: 'Appliquer des filtres',
                clear_filters: 'filtres à claire',
                country_codes: 'codes de pays',
                city: 'ville',
                favorites: 'favoris',
                postal_code: 'Code Postal',
                nearby_range: 'Gamme de suggestions de code postal à proximité',
                apply: 'appliquer',
                sliderinfo: 'incréments de 100',
                slidertooltip: '<p><strong> Le curseur de plage ajuste les chiffres du code postal entré pour agrandir la zone de recherche. </strong><p> Chaque étape augmente le code postal de 100. </p><p> Par exemple, à',
                option_labels: {
                    date_filter: {
                        upcoming: 'prochaine',
                        this_week: 'cette semaine',
                        next_week: 'la semaine prochaine',
                        in_two_weeks: 'Dans deux semaines +',
                        this_month: 'ce mois-ci',
                        specific_dates: 'dates spécifiques',
                        all: 'toute'
                    },
                    favorites: {
                        all: 'toute',
                        favorites: 'Favoris',
                        likes: 'ne montre que mes événements aimé',
                        favorites_likes: 'Show a aimé les événements ou les événements de marques favorisées',
                    },
                    organization_type: {
                        all: 'toute',
                        dance_schools: 'écoles de danse',
                        organizers: 'organisatrices',
                        music_styles: 'styles musicaux',
                        music_style: 'style musical',
                        artists: 'Enseignants et interprètes',
                        disk_jockeys: 'DJ',
                    },
                    user_type: {
                        professional: 'professionnelle',
                        ambassador: 'ambassadrice',
                        admin: 'administrer',
                        superadmin: 'superadmin'
                    }
                }
            },
            workshop_bootcamp: {
                title: 'ateliers et bootcamps',
            },
        },
        type: {
            festivals_and_congresses: 'festivals et congrès',
            try_out: 'Essayer, journée portes ouvertes, début des cours',
            live_music: 'groupes / musique live',
            workshop_bootcamp: 'ateliers et bootcamps',
        },
        categories: {
            festival: 'Festival / Congrès',
            workshop_bootcamp: 'atelier / bootcamp',
            workshop_bootcamp_party: 'fête avec atelier / bootcamp',
            party_social: 'parti / social',
            competition: 'concours',
            performance_concert: 'performance / concert',
            outdoor_event: 'événement en plein air',
            dance_trip: 'voyage de danse',
            party_live_music: 'fête / musique live',
            online_event: 'événement en ligne',
            try_out: 'Essayer, journée portes ouvertes, début des cours',
            show: 'montrer',
            marathon: 'marathon',
            weekender: 'tiers',
            retreat: 'Retreat',
            other: 'autre',
        },
        create: 'créer un événement',
        edit: 'Modifier l\'événement',
        remove: {
            label: 'supprimer l\'événement',
            description: 'Cela supprimera l\'événement et toutes les données associées.',
        },
        brand: 'marque/organisation',
        name: 'nom',
        country: 'pays',
        city: 'ville',
        street: 'rue',
        street_number: 'numéro de rue',
        short_description: 'Brève description',
        long_description: 'longue description',
        dance_styles: 'Styles de danse',
        music_styles: 'styles musicaux',
        photos: 'photos',
        photos_preview_mode: 'Les photos sont visibles après enregistrer en mode prévisualisation',
        preview: 'montrer',
        category: 'type d\'événement',
        language: 'langue',
        location_type: {
            singular: 'type d\'emplacement',
            online: 'virtuelle',
            offline: 'en personne',
        },
        timezone: 'fuseau horaire',
        date: 'date',
        week: 'semaine',
        start: 'commencer',
        end: 'fin',
        location: 'emplacement',
        information: 'information',
        start_date: 'date de début',
        start_time: 'heure de début',
        end_date: 'date de fin',
        end_time: 'heure de fin',
        ends_at: 'se termine',
        registration_opens_at: 'L\'inscription s\'ouvre à',
        registration_closes_at: 'L\'inscription se termine à',
        is_public: 'Prêt à partir en direct?',
        location_name: 'nom de lieu',
        photos_required: 'Au moins une photo est requise.',
        tickets_sold: 'Billets vendus',
        actions: 'actes',
        participate: 'participer',
        verified: 'Brand Officiel vérifié',
        undercondition: 'pas encore confirmé',
        warning: 'Changement important - Dernière mise à jour:',
        ticket:'Tickets available',
        cancelled: 'Annulé - Dernière mise à jour:',
        upcoming: 'événements à venir',
        past: 'événements passés',
        status: 'statut',
        status_reason: 'Raison de statut',
        entrance: 'Prix des billets',
        entrance_tooltip: 'Vous pouvez spécifier ici le prix du billet. Saisissez un nombre si le prix reste inchangé, par exemple: \'5\'. Pour une fourchette de prix, vous pouvez spécifier une fourchette, par exemple: \'5-10\'. Utilisez \'free\' s\'il n\'y a pas de prix d\'entrée.',
        currency: 'devise',
        currency_tooltip: 'Il est également possible de spécifier la devise. Les devises fréquemment utilisées sont: l\'euro (€), le dollar américain ($), la livre sterling (£), la livre turque (₺) et la roupie indienne (₹). Si aucune devise n\'est sélectionnée, vous pouvez ajouter un texte, par exemple \'5-12 euros\'.',
        repeat: 'répétitions',
        djs: 'DJ',
        dj: 'DJ',
        artists: 'artistes',
        artist: 'artiste',
        question: "Votre événement?",
        status_options: {
            active: 'active',
            canceled: 'annulé',
            pending: 'pas encore confirmé',
            changed: 'changement important',
        },
        is_public_options: {
            draft: 'brouillon',
            private: 'privée',
            public: 'publique',
            draft_message: 'Enregistrez votre événement en tant que projet.',
            private_message: 'Votre événement ne sera visible que pour les utilisateurs avec accès.',
            public_message: 'Publiez votre événement pour le rendre visible sur la page des événements.',
            private_warning: 'Votre événement n\'est pas visible en ligne avec ce statut.'
        },
        legend: {
            title: 'légende',
            verified: 'Brand Officiel vérifié',
            not_verified: 'Non vérifié par l\'organisation: l\'organisateur n\'a pas encore confirmé l\'activité.',
            cancelled: 'annulé',
            warning: 'changement important',
            posted_by: 'Publié par l\'ambassadeur de Latinmap',
            condition: 'pas encore confirmé',
            ticket:'Billets disponibles',
            duplicate_event_error: 'Un événement avec ce nom, la date de début et la date de fin existe déjà',
            ticket_order: 'Billets disponibles, commandez-les ici !'
        },
        ticket_types: 'types de billets',
        potential_duplicates: 'doublons possibles',
        proceed_anyway: 'Enregistrer malgré le double',
        duplicate_event_error: 'Un événement avec ce nom, la date de début et la date de fin existe déjà',
        event_deleted: 'événement supprimé',
        error_deleting_event: 'Événement de suppression d\'erreur',
        featured: {
            title: 'événements en vedette dans la communauté',
            subtitle: 'Découvrez et obtenez vos billets pour les festivals de danse, les concerts et les voyages au meilleur prix!',
            badge: 'À la une',
            view: 'Voir l\'événement',
            title_page: 'Changer le prix mondial',
            featured_event: "Acheter un événement en vedette",
            duration_type: "Type de durée",
            day: "jour",
            month: "mois",
            year: "année",
            duration: "durée",
            price: "prix",
            calculate_price: "calculer le prix",
            proceed_to_payment: "procéder au paiement",
            current_price: "prix actuel",
            no_price_found: "Aucun prix trouvé pour la durée sélectionnée",
            update_price: "mettre à jour le prix",
            setFeaturedEvents: "Événement en vedette",
            fetch_current_price: "Répondre au prix actuel",
            update_global_event_price: "Mettre à jour le prix de l\'événement mondial",
            price_per_day: 'prix par jour',
            buy: 'Acheter un événement en vedette',
            duration_label: 'Pendant combien de temps aimeriez-vous présenter l\'événement?',
            enter_duration: 'Sélectionner la durée',
            total_price: 'totale',
            yes: "Oui",
            no: "Non",
            invalid_invoice: 'Quelque chose s\'est mal passé, réessayez',
            download_failed: 'Quelque chose s\'est mal passé, réessayez',
            setFeaturedEvent: 'Événement en vedette pour:',
            setFeatured: 'Événement en vedette',
            featured_success: 'L\'événement a été présenté avec succès.',
            already_featured: 'Cet événement est déjà présenté',
            featured_error: 'Quelque chose s\'est mal passé',
            durationError: 'la valeur ne peut pas être inférieure à 1'
        },
    },
    blocked_user:{
        create: 'Create blocked user',
        edit: 'Mettre à jour l\'utilisateur bloqué',

        blocked_email: 'e-mail bloqué',
        blocked_phone_number: 'numéro de téléphone bloqué',
        reason: 'raison',

        delete: {
            warning: {
                title: 'Supprimer le blocage des utilisateurs',
                body: 'Êtes-vous sûr que vous souhaitez supprimer ce bloc.'
            }
        }
    },
    carousel: {
        title: 'Découvrez la danse latine - Événements, écoles, essais et plus près de chez vous !',
        subtitle: 'Trouvez où danser, apprendre et vous connecter avec la communauté latine.',
        search: {
            placeholder: 'Entrez un mot-clé ou une ville pour explorer les options de danse latine...',
            button: 'DÉCOUVRIR',
        }
    },
    home: {
        // LA-179: the official Instagram strip that closes the homepage.
        instagram: {
            title: 'En direct de la piste',
            subtitle: 'Les dernières publications de notre Instagram : la scène telle qu\'elle est, semaine après semaine.',
            follow: 'Suivre {handle}',
            post_alt: 'Une publication de {handle} sur Instagram',
        },
        cta_block_1: {
            title: 'Organisez-vous des événements de danse ?',
            subtitle:
                "Si vous organisez des soirées, festivals, sorties, congrès, week-ends, ateliers, stages intensifs et concerts de danse, nous avons quelque chose pour vous. Faites la promotion de votre événement, gérez les promoteurs et vendez des billets !",
            button: "S'inscrire maintenant"
        },
        cta_block_2: {
            title: 'Découvrez les Événements Près de Chez Vous',
            subtitle:
                'Découvrez les événements et activités dans votre région. Explorez et profitez des expériences !',
            placeholder: 'Votre emplacement',
            input_button: 'Près de chez moi',
            button: 'Trouver des événements'
        },
        cta_block_3: {
            button: 'Créer un Événement',
        },
        choose_and_live_experiences: 'Choisissez et vivez des expériences',
        experiences: {
            festivals_congresses: "Festivals & Congrès",
            parties_socials: "Soirées, Sociales",
            try_outs_start_courses: "Cours d'essai, Cours de démarrage",
            dance_schools: "Écoles de danse",
            workshops_bootcamps: "Ateliers, Bootcamps",
            dancewear_shoes: "Vêtements & Chaussures de danse",
            teachers: "Professeurs",
            show_performers_teams: "Artistes & Équipes de spectacle",
            djs: 'DJ\'s',
            live_music: "Groupes live",
            media_photo_video: "Médias (Photo/Vidéo)",
            mcs: "MC's"
        },
        cta_journey: {
            title: 'Commencez votre voyage LatinMap',
            subtitle: 'Choisissez comment vous voulez vivre LatinMap',
            agenda: {
                title: 'Agenda Mondial',
                sub_header: 'Accès libre',
                subtitle: 'Explorez la scène mondiale de la danse latine',
                description: 'Parcourez les soirées, ateliers, festivals, cours d\'essai et cours débutants - tout en un seul agenda',
                button: 'Voir le Latin Agenda',
                footer: 'Aucun compte requis'
            },
            member: {
                title: 'Devenir Membre',
                sub_header: 'Compte gratuit',
                subtitle: 'Construisez votre propre expérience LatinMap',
                description: 'Créez votre LatinMap personnel et restez connecté à la scène de danse latine — localement et internationalement.',
                features: {
                    agenda: 'Agenda complet et à jour de danse latine',
                    follow: 'Suivez vos événements, artistes et marques préférés',
                    save: 'Enregistrez vos favoris en un clic',
                    store: 'Stockez vos recherches et découvertes',
                    custom_agenda: 'Créez votre propre agenda personnalisé',
                    explore: 'Explorez de nouvelles villes, styles et scènes'
                },
                button: 'Créer un compte gratuit',
                footer: 'Gratuit – ne manquez plus jamais un événement'
            },
            professional: {
                title: 'Devenir Professionnel',
                sub_header: 'Profil professionnel gratuit',
                subtitle: 'Pour les festivals, écoles de danse, professeurs, DJs, musiciens et organisateurs',
                description: 'Augmentez votre visibilité, gérez vos événements et atteignez la communauté latine internationale.',
                features: {
                    brand_page: 'Votre propre page de marque professionnelle',
                    publish: 'Publiez et gérez des événements facilement',
                    invite: 'Invitez des membres de l\'équipe à collaborer',
                    insights: 'Statistiques et outils de croissance',
                    exposure: 'Exposition internationale sur LatinMap'
                },
                button: 'Activer le compte Pro',
                footer: 'Nécessite d\'abord un compte Membre'
            }
        },
    },
    dropzone: {
        drop_here: 'Déposez les fichiers ici pour télécharger',
        files_required: "{comte} requis",
        max_filesize: "Taille maximale du fichier: {max} MB"
    },
    general: {
        select_organization_please: "Veuillez sélectionner une organisation",
        no_organization_selected: "Aucune organisation sélectionnée",
        all: 'toute',
        styles: 'styles',
        important_information: 'Informations importantes',
        starts_at: 'depuis',
        ends_at: 'à',
        socialmedia_links: 'links',
        share_with_your_friends: 'Partagez avec vos amis',
        link_copied: 'Lien copié dans le presse-papiers !',
        link_copy_failed: 'Échec de la copie du lien.',
        hosted_by: 'hébergé par',
        created_by: 'créé par',
        posted_by: 'Publié par',
        created: 'créé',
        archive: 'Archive',
        modified: 'modifié',
        score: 'score',
        reset: 'réinitialiser',
        unknown: 'inconnue',
        submit: 'soumettre',
        suggest: 'suggérer',
        other: 'autre',
        delete: 'supprimer',
        copy_link: 'Copier le lien',
        back: 'dos',
        show: 'montrer',
        duplicate: 'double',
        proceed: 'procéder',
        cancel: 'Annuler',
        accept: 'Accepter',
        reject: 'rejeter',
        show_in_new_window: 'montrer dans une nouvelle fenêtre',
        checkout: 'vérifier',
        external_link_warning: {
            title: 'Lien externe',
            content: 'Vous êtes sur le point de quitter ce site.',
            question: 'Voulez-vous continuer vers l\'URL suivante ?',
        },
        add: 'ajouter',
        date: 'date',
        search: {
            save_new: 'Enregistrer une nouvelle recherche',
            instructions: 'Enregistrez votre recherche pour l\'utiliser à nouveau plus tard.',
            name: 'nom',
            none_stored: 'Vous n\'avez pas encore de recherches enregistrées.',
            stored: 'Recherches enregistrées',
            events: 'événements',
            organizations: 'organisations',
            paginate: 'par page',
            page: 'page',
            view: 'voir',
            filters: 'filtres',
            delete: 'supprimer',
            views: {
                grid: 'grille',
                list: 'liste',
                agenda: 'ordre du jour',
                monthlist: 'liste des mois',
            },
            filter_labels: {
                name: 'nom',
                location: 'emplacement',
                dance_styles: 'Styles de danse',
                music_styles: 'styles musicaux',
                event_categories: 'catégories d\'événements',
                date_filter: 'date',
                favorites: 'favoris',
                country_codes: 'codes de pays',
                organization_type: 'types d\'organisation',
            },
        },
        socials: {
            facebook: 'facebook',
            instagram: 'Instagram',
            site: 'site web',
            linkedin: 'liendin',
            youtube: 'youtube',
            tiktok: 'Tiktok',
            reddit: 'reddit',
            pinterest: 'pinterest',
            twitter: 'x',
            spotify: 'Spotify',
            soundcloud: 'SoundCloud',
            facebook_event: 'Événement Facebook',
            whatsapp: 'whatsapp',
        },
        description: {
            title: 'description',
            show_more: 'montrer plus',
            show_less: 'montrer moins',
        },
        map: 'carte',
        gmap_block: {
            title: 'carte',
            location_name: 'nom de lieu'
        },
        spotify_block: {
            title: 'Spotify',
        },
        soundcloud_block: {
            title: 'SoundCloud',
        },
        paginate: {
            results: 'résultats',
            filter: 'filtre',
            open_filter: 'filtre ouvré',
        },
        edit: 'modifier',
        create: 'créer',
        expand: 'plus',
        more_info: 'Plus d\'informations',
        collapse: 'moins',
        unique_impressions: 'Impressions uniques',
        close: 'fermer',
        save_changes: 'Enregistrer les modifications',
        update_changes: 'Enregistrer les modifications',
        scrollright: 'Faites défiler correctement pour plus de détails.'
    },
    header: {
        title: 'LatinMap',
        navigation: 'navigation',
        cta: 'créer un événement',
    },
    date: {
        from: 'depuis',
        to: 'à',
    },
    report: {
        event: 'Signaler l\'événement',
        organization: 'rapport de rapport',
        name: 'nom',
        location: 'emplacement',
        date: 'date',
        success: 'Votre rapport a été soumis avec succès.',
        not_logged_in: 'compte requis',
        tooltip: 'rapport',
        status: {
            warning: {
                title: 'Mettre à jour le statut du rapport',
                body: 'Êtes-vous sûr de vouloir modifier le statut de ce rapport?'
            }
        },
        archive: {
            warning: {
                title: 'rapport d\'archives',
                body: 'Êtes-vous sûr de vouloir archiver ce rapport? Cette action est irréversible.'
            }
        }
    },
    form: {
        save: 'sauvegarder',
        save_and_verify: 'Enregistrer et vérifier',
        too_many_requests: "Vous avez atteint la limite de messages. " +
            "Veuillez patienter quelques minutes avant d'envoyer une autre demande.",
    },
    form_subject: {
        general_inquiry: "enquête générale",
        technical_support: "support technique",
        issue_event_submission: "Problème de soumission des événements",
        issue_account_login: "Compte ou problème de connexion",
        question_billing_payment: "Question de facturation ou de paiement",
        report_issue: "Signaler un problème",
        suggest_feature: "suggestion de fonctionnalités",
        other: "autre"
    },
    api: {
        general: {
            validation_error: 'erreur de validation',
            permission_denied: 'Permission refusée',
            success: 'succès',
        },
        auth: {
            unauthorized: 'Vous n\'êtes pas autorisé à accéder à cette ressource.',
            blocked: 'Votre compte a été bloqué, vous ne pourrez accéder à aucune fonctionnalité.',
            user_not_found: 'Un compte est requis pour utiliser cette fonctionnalité, veuillez d\'abord créer un compte.',
            email_password_unknown: 'L\'adresse e-mail ou le mot de passe fourni est incorrect.',
            email_unverified: 'Votre adresse e-mail n\'est pas vérifiée.',
            email_already_verified: 'Votre adresse e-mail est déjà vérifiée.',
            phone_already_verified: 'your phonenumber is already verified.',
            phone_already_used: 'Ce numéro de téléphone est déjà utilisé',
            invalid_verification_link: 'Le lien de vérification fourni n\'est pas valide.',
            email_verified_success: 'Votre adresse e-mail a été vérifiée.',
            verification_email_sent: 'Un lien de vérification a été envoyé à votre adresse e-mail.',
            login_success: 'Vous vous êtes connecté avec succès.',
            logout_success: 'Vous vous êtes déconnecté avec succès.',
            registration_success: 'Vous vous êtes inscrit avec succès.',
            failed: 'Ces informations d\'identification ne correspondent pas à nos enregistrements.',
            password: 'Le mot de passe fourni est incorrect.',
            throttle: 'Trop de tentatives de connexion.',
            user_updated_success: 'Votre compte a été mis à jour avec succès.',
            old_password_incorrect: 'L\'ancien mot de passe fourni est incorrect.',
            password_changed_success: 'Votre mot de passe a été modifié avec succès.',
            user_deleted_success: 'Votre compte a été supprimé avec succès.',
            verification_text_sent: 'Un texte de vérification a été envoyé à votre numéro de téléphone.',
            invite_invalid: 'L\'URL de l\'invitation utilisée n\'est pas valide.',
            too_many_requests: 'Too many requests. Please try again later.',
            day_limit_exceeded: 'Vous avez dépassé le montant maximal des demandes de cette fonctionnalité aujourd\'hui.'
        },
        organization: {
            created_success: 'L\'organisation a été créée avec succès.',
            authorized_person: {
                created: 'La personne autorisée a été créée avec succès.',
                updated: 'La personne autorisée a été mise à jour avec succès.',
                removed: 'La personne autorisée a été supprimée avec succès.',
                not_found: 'La personne autorisée n\'a pas pu être trouvée.',
                already_exists: 'La personne autorisée existe déjà.',
                role: {
                    singular: 'rôle',
                    invalid: 'Le rôle fourni n\'est pas valide.',
                    eventPublisher: 'éditeur d\'événements',
                    eventCreator: 'Créateur d\'événements',
                    authorizedPerson: 'personne autorisée',
                }
            },
        },
        event: {
            created_success: 'L\'événement a été créé avec succès.',
            deleted_success: 'L\'événement a été supprimé avec succès.',
        },
        report: {
            created_success: 'Le rapport a été créé avec succès.',
            invalid_type: 'Le type de rapport fourni n\'est pas valide.',
        },
        user: {
            updated_success: 'L\'utilisateur a été mis à jour avec succès.',
            search_filter: {
                created: 'créé',
            }
        },
        upload: {
            created_success: 'Le téléchargement a été créé avec succès.',
            deleted_success: 'Le téléchargement a été supprimé avec succès.',
        },
        forms: {
            submitted_success: 'Le formulaire a été soumis avec succès.',
        },
        passwords: {
            reset: 'Votre mot de passe a été réinitialisé.',
            sent: 'Nous avons envoyé un e-mail à votre lien de réinitialisation de mot de passe!',
            throttled: 'Veuillez patienter avant de réessayer.',
            token: 'Ce jeton de réinitialisation de mot de passe n\'est pas valide.',
            user: 'Nous ne pouvons pas trouver un utilisateur avec cette adresse e-mail.',
        },
        pagination: {
            previous: '&laquo; précédente',
            next: 'Suivant &raquo;',
        },
        dance_style: {
            saved_success: 'Le style de danse a été sauvé.',
            deleted_success: 'Le style de danse a été supprimé avec succès.',
            deleted_error: 'Erreur de suppression du style de danse',
            not_found: 'Le style de danse n\'a pas pu être trouvé.',
            parent_not_found: 'Le style de danse parent n\'a pas pu être trouvé.',
            suggest_success: 'Suggestion de style de danse envoyée.',
        },
        music_style: {
            saved_success: 'Le style musical a été sauvé.',
            deleted_success: 'Le style musical a été supprimé avec succès.',
            not_found: 'Le style musical n\'a pas pu être trouvé.',
            parent_not_found: 'Le style de musique parent n\'a pas pu être trouvé.',
            suggest_success: 'Suggestion de style musical envoyé.',
        },
        invite: {
            sent: 'invitation envoyée',
            removed: 'invitation supprimée',
            resend_success: 'Résumé de l\'invitation'
        },
        transfer_request: {
            already_owner: 'Vous êtes déjà le propriétaire de cette organisation.',
            organization_already_owns_event: 'L\'organisation possède déjà l\'événement.',
        },
        transferlink: {
            removed: 'Le lien de transfert a été supprimé.'
        },
        user_block: {
            create_success: 'Le bloc utilisateur a été créé avec succès.',
            update_success: 'User block was successfully updated.',
            delete_success: 'User block was successfully deleted.'
        },
    },
    favorites: {
        favorite: 'préférée',
        like: 'comme',
        login_required: 'Vous devez être connecté pour ajouter cela à vos favoris.',
    },
    likes: {
        login_required: 'Vous devez être connecté pour ajouter cela à vos goûts.',
    },
    validations: {
        validations: {
            doesnt_exist: {
                'owner id': 'Impossible de trouver l\'utilisateur pour créer cette organisation au nom de.'
            }
        },
        on_behalf_of: {
            required: 'le nom du champ est requis.',
        },
        required: 'Ce champ est obligatoire.',
        phone: {
            required: 'le numéro de téléphone est requis.',
            regex: 'Le numéro de téléphone n\'est pas valide.',
            length: 'Le numéro de téléphone doit durer au moins 10 chiffres.',
        },
        'phone number': {
            required: 'le numéro de téléphone est requis.',
            regex: 'Le numéro de téléphone n\'est pas valide.',
            'not-unique': 'Ce numéro de téléphone est déjà utilisé.',
        },
        number: {
            required: 'le nombre est requis.',
            invalid: 'Le nombre n\'est pas valide.'
        },
        email: {
            required: 'L\'adresse e-mail est requise.',
            invalid: 'L\'adresse e-mail n\'est pas valide.',
            'not-unique': 'The email addres is not unique.'
        },
        name: {
            required: 'le nom est requis.',
            max_length: 'Le nom est trop long.',
        },
        username: {
            required: 'Le nom d\'utilisateur est requis.',
            invalid: 'Le nom d\'utilisateur n\'est pas valide.',
        },
        first_name: {
            required: 'le prénom est requis.',
        },
        last_name: {
            required: 'le nom de famille est requis.',
        },
        gender: {
            required: 'Le sexe est requis'
        },
        city: {
            required: 'la ville est requise.',
        },
        street: {
            required: 'La rue est requise.',
        },
        street_number: {
            required: 'Le numéro de rue est requis.',
        },
        country: {
            required: 'le pays est requis.',
        },
        brand: {
            required: 'La marque est requise.'
        },
        short_description: {
            required: 'La brève description est requise.',
        },
        long_description: {
            required: 'la longue description est requise.',
        },
        description: {
            required: 'la description est requise.',
        },
        type: {
            required: 'Le type est requis.',
        },
        message: {
            required: 'le message est requis.',
        },
        date_of_birth: {
            required: 'la date de naissance est nécessaire.',
            regex: 'La date de naissance n\'est pas valide.',
            age: 'Vous devez avoir au moins 18 ans.',
            old: 'Vous devez avoir au plus 120 ans.'
        },
        date: {
            required: 'la date est requise.',
            regex: 'La date n\'est pas valide.',
        },
        postal_code: {
            required: 'Le code postal est requis.',
            length: 'Le code postal doit avoir au moins 4 chiffres de long.',
        },
        entrance: {
            required: 'Les prix des billets sont obligatoires',
        },
        repeat: {
            required: 'La répétition est requise.',
        },
        password: {
            required: 'le mot de passe est requis.',
            regex: 'mot de passe valide requis.',
            confirmed: 'La confirmation du mot de passe ne correspond pas.',
            mismatch: 'Le mot de passe ne correspond pas.',
        },
        conditions: {
            required: 'Vous devez accepter les termes et conditions.',
        },
        url: {
            required: 'L\'URL est requise.',
            regex: 'L\'URL n\'est pas valide.',
        },
        event_category: {
            required: 'Le type d\'événement est requis.',
        },
        language_code: {
            required: 'la langue est requise.',
        },
        timezone: {
            required: 'Le fuseau horaire est requis.',
        },
        is_public: {
            required: 'la visibilité est requise.',
        },
        form_subject: {
            required: 'le sujet est requis.',
        },
        starts_at: {
            required: 'La date de début est requise.',
            regex: 'La date de début n\'est pas valide.',
        },
        start_date: {
            required: 'La date de début est requise.',
            regex: 'La date de début n\'est pas valide.',
            after_end_date: "La date de début doit être avant la date de fin.",
        },
        start_time: {
            required: 'l\'heure de début est requise.',
            regex: 'L\'heure de début n\'est pas valide.',
        },
        end_date: {
            required: 'la date de fin est requise.',
            regex: 'La date de fin n\'est pas valide.',
            before_start_date: "La date de fin doit être après la date de début.",
        },
        end_time: {
            required: 'l\'heure de fin est requise.',
            regex: 'L\'heure de fin n\'est pas valide.',
        },
        ends_at: {
            required: 'la date de fin est requise.',
            regex: 'La date de fin n\'est pas valide.',
            before_start_date: "La date de fin doit être après la date de début.",
        },
        registration_opens_at: {
            required: 'La date de début de l\'enregistrement est requise.',
            regex: 'La date de début de l\'enregistrement n\'est pas valide.',
        },
        registration_closes_at: {
            required: 'La date de fin de l\'enregistrement est requise.',
            regex: 'La date de fin de l\'enregistrement n\'est pas valide.',
        },
        location_type: {
            required: 'Le type d\'emplacement est requis.',
        },
        location_name: {
            required: 'Le nom de l\'emplacement est requis.',
        },
        dance_styles: {
            required: 'Les styles de danse sont nécessaires.',
        },
        music_styles: {
            required: 'Les styles de musique sont nécessaires.',
        },
        photos: {
            required: 'Au moins 1 photo est requise.',
        },
        status: {
            required: 'le statut est requis.',
        },
        string: {
            required: '{fieldname} est requis.',
            mismatch: '"{input}" does not match "{safeword}".',
        },
        role: {
            required: 'le rôle est requis.',
        },
        favorite: {
            required: 'le favori est nécessaire.',
        },
        dance_style: {
            required: 'Le style de danse est requis.',
        },
        facebook: {
            required: 'Le lien Facebook est requis.',
            regex: 'Veuillez saisir un lien Facebook valide.',
        },
        facebook_event: {
            required: 'Le lien de l’événement Facebook est requis.',
            regex: 'Saisissez une URL d’événement Facebook — doit pointer vers facebook.com/events/{id}.',
        },
        instagram: {
            required: 'Le lien Instagram est requis.',
            regex: 'Veuillez saisir un lien Instagram valide.',
        },
        website: {
            required: 'Le lien du site Web est requis.',
            regex: 'Veuillez saisir un lien de site Web valide.',
        },
        twitter: {
            required: 'La liaison x est requise.',
            regex: 'Veuillez saisir un lien X valide.',
        },
        linkedin: {
            required: 'Le lien LinkedIn est requis.',
            regex: 'Veuillez saisir un lien LinkedIn valide.',
        },
        youtube: {
            required: 'Le lien YouTube est requis.',
            regex: 'Veuillez saisir un lien YouTube valide.',
        },
        spotify: {
            required: 'le lien Spotify est requis.',
            invalid: 'Veuillez saisir un lien Spotify valide dans le format correct.',
            regex: 'Veuillez saisir un lien Spotify valide dans le format correct.',
        },
        soundcloud: {
            required: 'le lien SoundCloud est requis.',
            invalid: 'Veuillez saisir un lien SoundCloud valide dans le format correct.',
            regex: 'Veuillez saisir un lien SoundCloud valide dans le format correct.',
        },
        doesnt_exist: {
            email: 'L\'adresse e-mail fournie n\'existe pas.',
            user: 'l\'utilisateur fourni n\'existe pas.',
        },
        djs: {
            required: 'Les DJ sont nécessaires.',
        },
        artists: {
            required: 'Les artistes sont nécessaires.',
        },
        reason: {
            required: 'la raison est requise.'
        },
        default: {
            doesnt_exist: {
                email: 'L\'adresse e-mail fournie n\'existe pas.',
                user: 'l\'utilisateur fourni n\'existe pas.',
            }
        }
    },
    brand_activity: {
        by_brand: 'utilisateur marque',
        by_admin: 'admin/scraping',
        export: 'Exporter CSV',
    },
    paginatable: {
        headers: {
            last_event_at: 'Dernière activité événement',
            last_event_by: 'Dernier événement par',
            has_upcoming: 'À venir publié',
            id: 'identifiant',
            brand_id: 'identité de marque',
            title: 'titre',
            slug: 'limace',
            group: 'groupe',
            email: 'adresse email',
            phone: 'numéro de téléphone',
            name: 'nom',
            first_name: 'prénom',
            last_name: 'nom de famille',
            role_name: 'rôle',
            role: 'rôle',
            report: 'rapport',
            created_at_formatted: 'créé à',
            status: 'statut',
            actions: 'actes',
            type: 'taper',
            to_user_email: 'à adresse email',
            from_user_email: 'de adresse email',
            reason: 'raison',
            organization_name: 'nom de l\'organisation',
            organization_created: 'Organisation créée',
            organization_updated: 'Organisation pour la dernière mise à jour',
            confirmed_at: 'confirmé à',
            organization_role: 'rôle',
            sub_dance_styles: 'styles de danse',
            sub_music_styles: 'styles de musique',
            city: 'ville',
            created_at: 'créé',
            updated_at: 'modifié',
            is_favorite: 'préférée',
            starts_at: 'commence à',
            tickets_sold: 'Billets vendus',
            price: 'prix',
            start_date: 'date de début',
            is_public: 'publique',
            available_tickets: 'Billets disponibles',
            user_id: 'ID de l\'utilisateur',
            transferable_type: 'taper',
            content_name: 'titre',
            paynl_transaction_id: 'transaction Paynl',
            date: 'date d\'achat',
            amount: 'montant total',
            tax_amount: 'impôt',
            currency: 'devise',
            description: 'description',
            valid_from: 'commencer',
            valid_until: 'expiration',
            items: 'articles',
            total: 'totale',
            featured: 'en vedette',
            created_by: 'utilisatrice',
            location_type: 'type d\'emplacement',
            category_id: 'catégorie',
            organization_category_id: 'catégorie',
            country_code: 'code du pays',
            location: 'emplacement',
            info: 'Informations sur l\'utilisateur',
            owner: 'représentation',
            adres: 'adresse',
            export_created: 'exportation créée',
            image_path: "Chemin de l'image",
            image_alt: "Texte alternatif",
            image_title: "Titre de l'image",
            image: "Image",
            visibility: "Visibilité",
            order_by: "Trier par",
            public_status: "Statut public",
            country: 'Pays',
            activity: 'Activité',
        },
        search: 'recherche',
        no_records: 'Aucun résultat trouvé',
    },
    pages: {
        related: 'pages connexes',
        contact: {
            title: 'Contacter Latinmap',
            body: 'Pour des questions liées aux événements, veuillez contacter l\'organisation qui a publié l\'événement.'
        },
        'how-it-works': {
            title: 'Comment ça marche',
            body: '<p> Ventes de billets en ligne via latinmap.com </p><p> Nous offrons aux organisations la possibilité de vente de billets en ligne.'
        },
        'goods-and-services': {
            title: 'biens et services',
            body: '<p> latinmap.com: Découvrez et découvrez le monde de la danse latine </p><p> Bienvenue sur latinmap.com, la destination où vous avez sans effort accès aux événements et expériences les plus excitants du monde de la danse latine.'
        },
        'terms-and-conditions': {
            title: 'termes et conditions',
            body: '<p>20230529 Conditions générales de vente de billets</p><p>1. Définitions</p><p>Les termes définis ici avec une majuscule initiale ont la signification suivante dans les présentes Conditions générales:<br/>a. Conditions générales: les présentes conditions générales de vente de billets de la Fondation LatinMap.com<br/>b. Événement: l\'événement organisé, tel qu\'un événement de nature musicale, culturelle, sportive et/ou récréative, pour lequel la Fondation LatinMap.com vend des billets<br/>c. Organisateur de l\'événement: la personne physique ou morale qui produit ou organise un événement et en est responsable<br/>d. Client: la personne physique ou morale qui conclut un accord avec la Fondation LatinMap.com relatif à un événement, ou à qui la Fondation LatinMap.com fait une offre pour le faire<br/>e. Contrat: l\'accord entre la Fondation LatinMap.com et le Client pour l\'acquisition de billets pour des événements<br/>f. Billet: le document qui sert de billet d\'entrée pour un événement, y compris les billets électroniques</p><p>2. Applicabilité</p><p>a. Les présentes Conditions générales s\'appliquent à toutes les offres, commandes, relations juridiques et accords dans lesquels la Fondation LatinMap.com livre des produits ou services de toute nature au Client, même si ces produits ou services ne sont pas (plus) décrits dans les présentes Conditions générales.<br/>b. La Fondation LatinMap.com rejette expressément l\'applicabilité de toute autre condition du Client.<br/>c. Les parties ne peuvent convenir de dérogations aux Conditions générales que par écrit. La Fondation LatinMap.com est en droit de modifier les Conditions générales et de déclarer les conditions générales modifiées applicables aux Accords. Les conditions générales modifiées peuvent être consultées sur le site Internet de la Fondation LatinMap.com. d. L\'Accord est soumis aux conditions générales de l\'Organisateur de l\'Événement. Si elles ne sont pas déjà en possession du Client, l\'Organisateur de l\'Événement enverra les conditions générales de l\'Organisateur de l\'Événement au Client sur demande.</p><p>3. Formation de l\'Accord</p><p>a. Sauf accord contraire par écrit, toutes les offres, y compris les publicités et les listes de prix mentionnées sur le site Web de la Fondation LatinMap.com, sont sans engagement. b. En proposant et en vendant des billets, la Fondation LatinMap.com agit en tant que médiateur dans la formation de l\'accord entre l\'acheteur et l\'organisateur de l\'événement. La Fondation LatinMap.com n\'est pas partie à l\'accord conclu par l\'achat d\'un billet. L\'accord est conclu après que le client a acheté un ou plusieurs billets via la Fondation LatinMap.com. La Fondation LatinMap.com fournit les billets au nom de l\'organisateur de l\'événement. c. Avant de confirmer sa réservation, le client doit toujours vérifier si les bons billets ont été réservés. Lors de la réservation, le client doit toujours utiliser une adresse (e-mail) correcte. Si le client choisit de recevoir les billets par voie électronique, le risque de perte, de vol ou d\'utilisation abusive du billet incombe au client à partir du moment où les billets lui sont parvenus. En cas de doute sur l\'exactitude des données saisies par le client lors de la commande, la Fondation LatinMap.com peut contacter le client en utilisant les données saisies par le client. Si la Fondation LatinMap.com ne peut pas joindre le Client et ne peut donc pas vérifier les données, la Fondation LatinMap.com peut procéder à l\'annulation de la réservation et vendre les Billets à un autre Client. Si la Fondation LatinMap.com doute de l\'exactitude ou de la validité des données saisies par le Client au moment de la commande ou du mode de paiement utilisé par le Client, elle a le droit d\'annuler la réservation du Client et de vendre les Billets à un autre Client. La Fondation LatinMap.com s\'efforcera d\'informer le Client dans un tel cas. Tout Contrat est conclu sous la condition suspensive de disponibilité suffisante des produits ou services respectifs.<br/>d. La Fondation LatinMap.com et/ou l\'Organisateur de l\'Événement se réservent le droit de fixer un nombre maximum de Billets pouvant être réservés/achetés. Si ce maximum est dépassé par le Client, la Fondation LatinMap.com et/ou l\'Organisateur de l\'Événement sont en droit d\'annuler la réservation des Billets au-delà du nombre maximum ou d\'invalider les Billets concernés.<br/>e. Les Billets ne peuvent pas être retournés. La disposition de l\'article 6:230p sub e BW s\'applique aux billets.</p><p>4. Prix et paiement</p><p>a. La Fondation LatinMap.com vend des billets pour le compte des organisateurs d\'événements qui déterminent le prix et le nombre de places disponibles. Les informations concernant le prix et la disponibilité sont fournies sans engagement et sous réserve de modifications.<br/>b. Le client paie les produits ou services commandés via le site Web, au prix mentionné dans le contrat. Le paiement est effectué de la manière indiquée sur le site Web de la Fondation LatinMap.com. Des conditions (de paiement/de commande) supplémentaires peuvent être appliquées à la commande.</p><p>c. Tous les prix de la Fondation LatinMap.com tels que mentionnés sur le site Web sont en euros, TVA comprise, sauf mention expresse contraire.<br/>d. La Fondation LatinMap.com facture des frais de service pour chaque commande. En outre, la Fondation LatinMap.com facture des frais administratifs calculés sur la base du montant total de la transaction.</p><p>e. Si le client ne paie pas les montants dus à temps, le client est, sans qu\'il soit nécessaire de procéder à une quelconque demande ou mise en demeure, tenu de payer des intérêts légaux sur le montant impayé. Si le Client ne parvient pas à régler la créance après une mise en demeure ou une mise en demeure, la Fondation LatinMap.com peut lui transmettre la créance, auquel cas le Client est également tenu de rembourser tous les frais judiciaires et extrajudiciaires, y compris les frais calculés par des experts externes en plus des frais légalement fixés.</p><p>5. Délais de livraison</p><p>a. Les tickets sont envoyés à l\'adresse (e-mail) fournie par le Client au moment de la commande. La Fondation LatinMap.com continuera à considérer l\'adresse (e-mail) fournie par le Client comme correcte jusqu\'à ce que le Client informe la Fondation LatinMap.com d\'une nouvelle adresse (e-mail). b. Les délais de livraison indiqués par la Fondation LatinMap.com ne seront jamais considérés comme un délai strict, sauf convention expresse contraire. En cas de livraison tardive, la Fondation LatinMap.com doit être mise en demeure par écrit.</p><p>c. Le dépassement d\'un délai de livraison ne donne pas droit au Client à une indemnisation ni au droit d\'annuler la commande ou de dissoudre le Contrat, sauf si le délai de livraison a été dépassé à un point tel qu\'il est déraisonnable d\'attendre du Client qu\'il maintienne le Contrat.</p><p>d. À l\'exception de la possibilité de commander des Billets électroniques, les ventes de Billets via le site Internet et le centre d\'appels sont arrêtées 8 jours avant la date de l\'Événement afin de donner à la Fondation LatinMap.com la possibilité de toujours envoyer les Billets par la poste.</p><p>6. Événements annulés et reprogrammés</p><p>a. Il incombe au Client de vérifier si un Événement a été annulé ou reprogrammé et quelle sera la nouvelle heure ou le nouveau lieu. Bien que Stichting LatinMap.com tentera d\'informer le Client de l\'annulation après avoir reçu les informations nécessaires de l\'Organisateur de l\'Événement, Stichting LatinMap.com ne peut garantir que le Client sera informé de l\'annulation avant la date de l\'Événement.</p><p>b. Stichting LatinMap.com n\'est pas responsable des frais encourus.<br/>c. Les billets pour les événements reprogrammés restent généralement valables pour l\'événement de remplacement. Pour plus d\'informations à ce sujet, le client peut contacter Stichting LatinMap.com via notre adresse e-mail : mail(at)LatinMap.com. Si un événement est déplacé vers un autre lieu ou une autre date, l\'organisateur de l\'événement peut imposer des conditions au remboursement du prix du billet.<br/>d. Si un événement est annulé ou reprogrammé, le client peut restituer les billets pour cet événement conformément à l\'arrangement déterminé par l\'organisateur de l\'événement. Pour les conditions pertinentes, nous vous renvoyons aux conditions générales de l\'organisateur de l\'événement. Si l\'organisateur de l\'événement demande à Stichting LatinMap.com de rembourser le prix du billet au client, Stichting LatinMap.com le fera après avoir reçu les fonds correspondants de l\'organisateur de l\'événement. Les frais de service et d\'administration ne sont pas remboursés. </p><p> 7. Billets </p><p> a. Les billets distribués par Stichting LatinMap.com restent la propriété de l\'organisateur de l\'événement. Le client n\'est pas autorisé à revendre un billet si cela est contraire à la loi. En outre, un organisateur d\'événement peut interdire la revente ou l\'utilisation commerciale d\'un billet. Le client doit vérifier cela dans les conditions générales de l\'organisateur, auxquelles il est fait référence sur le billet (et lors du processus de commande). En cas de revente (tentative) ou d\'utilisation commerciale en violation de la loi ou des conditions de l\'organisateur de l\'événement, ce dernier est en droit d\'invalider le billet concerné et/ou d\'imposer une amende au client. Les détenteurs de cartes d\'accès non valides se verront refuser l\'accès à l\'événement, sans aucun droit à indemnisation.<br/>b. Dès réception, le client doit vérifier les billets, car les erreurs ne peuvent pas toujours être corrigées. Après l\'achat, les billets ne peuvent pas être échangés ou remboursés.<br/>c. Si le billet du client est endommagé au point que son authenticité ne peut plus être vérifiée, le client peut contacter le service client en ligne.<br/>d. Les demandes spéciales, telles que la réservation de places pour fauteuil roulant, doivent être communiquées en temps utile et de manière explicite. Stichting LatinMap.com ne peut garantir que les demandes spéciales pourront être satisfaites. Pour plus d\'informations à ce sujet, le client peut contacter Stichting LatinMap.com via notre adresse e-mail : mail(at)LatinMap.com </p><p> 8. Droits de propriété intellectuelle et industrielle </p><p> a. Les droits de propriété industrielle et intellectuelle reposant sur le billet de Stichting LatinMap.com appartiennent à Stichting LatinMap.com ou à son concédant de licence. Le client s\'abstiendra de toute action qui pourrait porter atteinte aux droits ou autres intérêts de Stichting LatinMap.com ou de son concédant de licence.<br/>b. Le Client n\'est pas autorisé à supprimer ou à modifier toute indication de droit d\'auteur, de marque déposée, de nom commercial ou d\'autres droits de propriété intellectuelle ou industrielle du Billet, ni à apporter des modifications à la forme ou à toute autre caractéristique du Billet.<br/>c. Il est interdit au Client de contrefaire, de dupliquer ou de reproduire le Billet de quelque manière que ce soit.<br/>d. L\'Accord ne s\'étend pas au transfert d\'un quelconque droit de propriété intellectuelle de Stichting LatinMap.com au Client. </p><p> 9. Confidentialité </p><p> a. Les données fournies par le Client lors de l\'achat de billets seront utilisées exclusivement par Stichting LatinMap.com pour améliorer ses services.<br/>b. Les données fournies par le Client lors de l\'achat de billets ne seront jamais mises à la disposition de tiers. </p><p> c. Les données fournies par le Client lors de l\'achat de billets seront mises à la disposition de l\'Organisation vendeuse. Il est possible que l\'organisation utilise les données pour envoyer des mailings.<br/>d. Nous attendons de nos clients qu\'ils traitent ces informations avec soin. Si ce n\'est pas le cas, nous aimerions en être informés et informerons le client concerné et, si nous le jugeons nécessaire, nous l\'exclurons de la vente de billets en ligne. </p><p> e. Remarque : nous déclinons toute responsabilité quant à la politique de confidentialité de nos clients. </p><p> 10. Responsabilité </p><p> a. Stichting LatinMap.com ne peut être considéré comme l\'organisateur (organisateur de l\'événement) de l\'événement et n\'est pas responsable ni ne garantit la qualité (artistique) et le contenu de l\'événement et le déroulement des événements dans ou autour de l\'événement, et n\'accepte aucune responsabilité sur cette base. </p><p> b. À l\'exception des autres dispositions de responsabilité des présentes conditions générales, la responsabilité totale de Stichting LatinMap.com en raison d\'une inexécution imputable ou d\'un acte illicite est limitée à l\'indemnisation des dommages directs jusqu\'à concurrence du montant qui a été ou peut être facturé au client pour les billets, à moins que le dommage ne soit le résultat d\'une intention et/ou d\'une négligence grave de </p><p> Stichting LatinMap.com ou de ses subordonnés.<br/> c. La responsabilité de Stichting LatinMap.com en cas de manquement imputable à un contrat n\'est engagée dans tous les cas que si le client déclare Stichting LatinMap.com en défaut par écrit, dans les meilleurs délais et de manière appropriée, en fixant un délai raisonnable pour remédier au manquement, et que Stichting LatinMap.com continue à manquer à ses obligations même après ce délai. La mise en demeure doit contenir une description du manquement aussi complète et détaillée que possible, afin que Stichting LatinMap.com puisse réagir de manière adéquate. d. Le client garantit Stichting LatinMap.com contre toutes les réclamations de tiers liées au manquement ou au respect insuffisant par le client de toute obligation envers Stichting LatinMap.com, qu\'elle résulte ou non des conditions générales. e. Une condition pour l\'existence d\'un droit à indemnisation est toujours que le client signale le dommage à Stichting LatinMap.com par écrit dès que possible après sa survenance. f. Stichting LatinMap.com ne peut en aucun cas être tenue responsable de toute forme de dommage ou de perte du Billet. En cas de perte ou de vol, le Client ne peut prétendre à un Billet de remplacement ni au remboursement d\'une somme quelconque. Stichting LatinMap.com n\'est pas non plus responsable des retards ou de la non-livraison ou de la livraison incorrecte des Billets, si le retard, la non-livraison ou la livraison incorrecte ne peuvent être imputés à Stichting LatinMap.com.<br/> g. Stichting LatinMap.com n\'assume aucune responsabilité pour les Billets obtenus auprès de tiers par le Client. Stichting LatinMap.com ne peut pas non plus garantir leur authenticité.<br/> h. Stichting LatinMap.com ne peut en aucun cas être tenue responsable de tout dommage subi par le détenteur de ce billet d\'entrée en raison des actions ou omissions de tiers. </p><p> 11. Force majeure </p><p> a. Par force majeure, on entend toute défaillance qui ne peut être imputée à Stichting LatinMap.com, car elle n\'est pas imputable à elle et qui n\'est pas imputable à elle en vertu de la loi, d\'un acte juridique ou des normes généralement acceptées.<br/> b. Sans préjudice de ses autres droits, Stichting LatinMap.com a le droit de suspendre l\'exécution de la commande du Client en cas de force majeure, en le notifiant au Client par écrit, et sans que Stichting LatinMap.com ne soit tenue à une quelconque indemnisation, à moins que cela ne soit inacceptable selon les normes de raison et d\'équité dans les circonstances données. </p><p> 12. Droit applicable et tribunal compétent </p><p> a. Tous les accords avec Stichting LatinMap.com sont régis par le droit néerlandais. </p><p> 13. Divers </p><p> a. Les clients qui arrivent en retard à l\'événement seront admis - dans la mesure du possible - à des moments appropriés de l\'événement. Cependant, l\'entrée ne peut être garantie.<br/> b. Lorsque les présentes conditions générales obligent Stichting LatinMap.com à faire une communication écrite, Stichting LatinMap.com est en droit de faire cette communication par voie électronique, comme, mais sans s\'y limiter, par un message électronique ou un fax.<br/> c. Les erreurs évidentes et les fautes de frappe sur le site Web de Stichting LatinMap.com ou dans les devis, confirmations de commande, billets et/ou autres documents, n\'engagent pas Stichting LatinMap.com. d. En cas de désaccord entre Stichting LatinMap.com et le Client concernant la traduction et/ou l\'interprétation des Conditions Générales, la version néerlandaise de celles-ci sera déterminante.<br/> e. Si une ou plusieurs dispositions des présentes Conditions Générales ou de tout autre accord avec Stichting LatinMap.com devaient être en conflit avec une exigence légale applicable, la disposition concernée sera nulle et remplacée par une nouvelle disposition comparable légalement autorisée à déterminer par Stichting LatinMap.com. </p>'
        },
        'privacy-policy': {
            title: 'politique de confidentialité',
            body: '<p> Politique de confidentialité pour Latinmap.com: Découvrez et découvrez le monde de la danse latine <br> Dernière mise à jour: 23-05-2023 <br> Merci d\'avoir visité Latinmap.com, la destination pour avoir découvert et expérimenté le monde de la danse latine.'
        },
        about: {
            'about-latin-scene': {
                title: "sur la scène latine",
                body: "La scène de danse latine est une communauté dynamique et diversifiée qui célèbre le riche patrimoine culturel de l\'Amérique latine à travers la musique, la danse et l\'art."
            },
            salsa: {
                title: "salsa",
                body: "La salsa est une forme populaire de danse sociale originaire des Caraïbes."
            },
            bachata: {
                title: "Bachata",
                body: "Bachata est un genre de musique latino-américaine qui est originaire de la République dominicaine dans la première moitié du 20e siècle avec des éléments musicaux européens, indigènes et africains."
            },
            zouk: {
                title: "Zouk",
                body: "Zouk est un style de musique de carnaval rapide de la musique rythmique provenant des îles des Caraïbes de Guadeloupe et de la Martinique, popularisée par les Antilles de Kassav français dans les années 1980."
            },
            kizomba: {
                title: "Kizomba",
                body: "Kizomba est un genre de genre musical et de danse provenant de l\'Angola à la fin des années 1970 et au début des années 1980."
            },
            cuban: {
                title: "cubaine",
                body: "La musique et la danse cubaines sont profondément enracinées dans le patrimoine culturel diversifié de l\'île, mélangeant des influences africaines, espagnoles et indigènes de l\'île."
            }
        },
        'help-center-faq': {
            title: 'Centre d\'aide',
        },
        'cookie-policy': {
            title: 'Politique de cookies',
        },
        'create-an-event': {
            title: 'Comment créer un événement',
        },
        'create-an-brand-or-an-organization': {
            title: 'Comment créer une marque',
        },
        'become-an-ambassador': {
            title: 'devenir ambassadeur',
        },
        'promote-your-event': {
            title: 'Comment promouvoir votre événement',
        },
        'professional-account-verification': {
            title: 'Vérification du compte professionnel'
        },
        'about-us': {
            title: 'À propos de nous',
        },
    },
    email: {
        'not-unique': 'l\'e-mail a déjà été pris.',
    },
    leads: {
        title: 'soumettre le plomb',
        description_p1: 'Vous êtes utilisateur de LatinMap et avez trouvé une école de danse, une organisation ou un événement qui n\'est pas encore répertorié ? Soumettez-le ici — votre contribution nous aide à maintenir la plateforme complète, précise et précieuse pour les danseurs du monde entier.',
        description_p2: 'Vous êtes organisateur et souhaitez être répertorié sur LatinMap ? Créez un compte Pro et ajoutez vos activités gratuitement à la plateforme !',
        description_p3: 'Merci de nous aider à développer LatinMap, la plateforme qui connecte la communauté mondiale de la danse.',
        plural: 'conduite',
        type: {
            event: 'événement',
            organization: 'organisation',
            label: 'taper',
        },
        name: 'nom',
        address: 'adresse',
        country: 'pays',
        city: 'ville',
        street: 'rue',
        street_number: 'numéro de rue',
        dance_styles: 'Styles de danse',
        music_styles: 'styles musicaux',
        photos: 'photos',
        category: 'type d\'événement',
        location_name: 'nom de lieu',
        location_type: {
            singular: 'type d\'emplacement',
            online: 'virtuelle',
            offline: 'en personne',
        },
        timezone: 'fuseau horaire',
        date: 'date',
        not_posted_by_ambassador: 'Vérifié par l\'organisateur',
        undercondition: 'à condition',
        warning: 'changement important',
        cancelled: 'annulé',
        posted_by_ambassador: 'Publié par l\'ambassadeur de Latinmap',
        upcoming: 'événements à venir',
        status_options: {
            active: 'active',
            canceled: 'annulé',
            pending: 'pas encore confirmé',
            changed: 'changement important',
            submitted: 'soumise',
            under_review: 'en cours d\'examen',
            implemented: 'mis en œuvre',
            declined: 'refusé',
        },
        submit: 'soumettre',
        success: 'Le plomb a été soumis.',
        filter_type: 'filtre par type',
        view: 'plomb',
        confirm_delete: 'Supprimer le plomb',
        delete_confirmation: 'Êtes-vous sûr de vouloir supprimer cet avance?',
        deleted_successfully: 'L\'avance a été supprimée avec succès.',
        error_loading: 'Erreur de chargement',
        status_updated: 'Le statut de lead a été mis à jour.',
        error_status: 'Erreur mise à jour de l\'état du fil',
    },
    search: {
        allOragnisations: 'Voir toutes les écoles de danse',
        allEvents: 'Voir tous les événements',
        searchresult: 'Résultats de la recherche',
        type: 'Taper',
        title: 'titre',
        city: 'ville',
        country: 'pays',
        address: 'adresse',
        startdate: 'date de début',
        favorite: 'préférée'
    },
    components: {
        picture_input: {
            drag: "Télécharger Avatar",
            remove: 'Supprimer l\'avatar',
            change_avatar: 'changer d\'avatar'
        },
        pictureInput: {
            drag: "Cliquez ici pour télécharger l'image",
            change: "Changer",
            remove: "Supprimer",
            upload: "Téléverser",
            tap: "Appuyez pour téléverser",
            select: "Sélectionner un fichier",
            selected: "Sélectionné",
            fileSize: "Taille du fichier",
            fileType: "Type de fichier",
            aspect: "Ratio d'aspect"
        },
    },
    passion: {
        title: "Ressens le Rythme, Rejoins le Mouvement",
        subtitle: "Découvre le monde vibrant de la danse latine. Connecte-toi avec des danseurs, trouve des événements près de chez toi et laisse la musique toucher ton âme.",
    },
    payment: {
        received: "paiement reçu",
        thank_you: "Merci pour votre achat!",
        download_ticket: "Télécharger le (s) billet (s)",
        download_button: "Télécharger le (s) billet (s)",
        email_check: "Veuillez vérifier votre boîte de réception, y compris le dossier SPAM, pour un e-mail de notre système de billetterie.",
        failed: "paiement en attente",
        failed_message: "Malheureusement, nous avons rencontré un problème de traitement de votre paiement.",
        download_invoice: "Télécharger la facture",
        download_invoice_button: "Télécharger la facture",
        invoice_check: "Veuillez cocher votre boîte de réception pour votre facture.",
        thank_you_for_purchase: "Merci d\'avoir acheté l\'événement en vedette!",
    },
    financial_center: {
        financial_dashboard: 'Mon tableau de bord financier',
        title: "place financière",
        description: "Gérez vos transactions, vos paiements, vos promotions et vos fonctionnalités premium.",
        overview: "aperçu",
        transactions: "transactions",
        payoutsettings: "Paramètres de paiement",
        featured_events: "événements en vedette",
        ticketsales: "Ventes de billets",
        premium: "comptes premium",
    },
    inputfield: {
        select_here: 'Sélectionnez ici',
    },
    tooltip: {
        edit: 'Modifier',
        delete: 'Supprimer',
        view: 'Voir',
        hide: 'Masquer',
        under_construction: 'En construction',
    },
    // LA-157: where someone stops the automated emails LatinMap sends.
    email_preferences: {
        error: "Une erreur s'est produite. Réessaie dans un instant.",
        confirm: {
            title: "Ne plus recevoir ces e-mails ?",
            body: "Tu reçois actuellement ces e-mails automatiques à {email}.",
            note: "Les messages concernant ton compte, comme la réinitialisation du mot de passe, continueront.",
            button: "Arrêter ces e-mails",
        },
        done: {
            title: "Tu ne recevras plus rien",
            body: "Nous n'enverrons plus d'e-mails automatiques à {email}.",
            undo: "Les recevoir à nouveau",
        },
        unknown: {
            title: "Ce lien ne fonctionne plus",
            body: "Le lien n'est pas valide. Utilise celui d'un e-mail plus récent.",
        },
    },
    // LA-194: the public page an organiser reaches through a submission link.
    submit_event: {
        eyebrow: 'Proposer un événement',
        title: 'Envoie ton événement à LatinMap',
        title_brand: 'Proposer un événement pour {brand}',
        lede: 'Remplis ce que tu sais. Nous le préparons et le publions après une courte vérification.',
        loading: 'Un instant…',
        notes: {
            no_account: 'Pas de compte nécessaire — ce lien suffit',
            checked: 'Nous vérifions chaque événement avant sa mise en ligne',
            reply: 'Si quelque chose n\'est pas clair, nous t\'écrivons',
        },
        sections: {
            event: 'L\'événement',
            where: 'Où',
            details: 'Détails',
            you: 'À propos de toi',
        },
        fields: {
            name: 'Nom de l\'événement',
            organizer_name: "Nom de l'organisateur / de la marque",
            organizer_url: "Site web ou réseaux sociaux de l'organisateur",
            start_date: 'Date',
            start_time: 'Heure de début',
            end_date: 'Date de fin',
            end_time: 'Heure de fin',
            dance_styles: 'Styles de danse',
            event_category: "Type d'événement",
            event_category_placeholder: "Choisis un type d'événement",
            location_name: 'Lieu',
            city: 'Ville',
            country: 'Pays',
            country_placeholder: 'Choisis un pays',
            short_description: 'Description courte',
            description: 'Description complète',
            link: 'Lien vers plus d\'informations ou billets',
            photo: "Photo",
            photo_remove: "Retirer la photo",
            your_name: 'Ton nom',
            your_email: 'Ton adresse e-mail',
        },
        hints: {
            organizer:
                'Qui organise cet événement ? Un lien vers son site ou son Instagram nous aide à trouver la bonne marque.',
            end_date: "Pour un événement d'une journée, c'est la même date que le début.",
            contact: 'Nous ne les utilisons que pour te contacter à propos de cet événement.',
            photo: "Facultatif. JPG, PNG ou WebP, jusqu'à 8 Mo.",
        },
        errors: {
            name: 'Indique le nom de l\'événement.',
            start_date: 'Indique la date.',
            end_date: "Indique la date de fin.",
            event_category: "Choisis un type d'événement.",
            too_many: "Tu as essayé trop de fois. Attends un moment et réessaie.",
            city: 'Indique la ville.',
            country: 'Choisis un pays.',
            organizer_name: 'Indiquez qui organise cet événement.',
            email: 'Indique une adresse e-mail valide.',
            failed: 'L\'envoi a échoué. Réessaie dans un instant.',
            photo_type: "Choisis un JPG, PNG ou WebP.",
            photo_size: "Cette photo est trop lourde. 8 Mo maximum.",
        },
        submit: 'Envoyer l\'événement',
        done: {
            title: 'Merci, nous avons ton événement',
            body: 'Quelqu\'un de LatinMap va le regarder. Tu recevras une confirmation par e-mail.',
            again: 'Proposer un autre événement',
        },
        invalid: {
            title: 'Ce lien ne fonctionne plus',
            body: 'Le lien a expiré ou a été retiré. Demandes-en un nouveau.',
        },
    },
    // LA-180: the screen Brevo returns to after a subscription is
    // confirmed. Top-level rather than under footer, because the same
    // confirmation ends both the footer form and the signup opt-in.
    newsletter: {
        // LA-176: the fixed sign-up landing page behind every QR code,
        // social bio and e-mail signature.
        stay_updated: {
            title: 'Restez au cœur de la scène',
            lede: 'Recevez les événements de danse latine pour lesquels on garde sa soirée : soirées, festivals, ateliers et cours d\'essai, ainsi que les nouveautés et les jeux-concours de LatinMap.',
            benefits: {
                agenda: 'L\'agenda, avant tout le monde',
                festivals: 'Les festivals et congrès qui valent le voyage',
                features: 'Les nouvelles fonctionnalités LatinMap dès leur sortie',
                community: 'Jeux-concours et actualités de la communauté',
            },
            form_title: 'S\'inscrire',
            email_label: 'Votre adresse e-mail',
            submit: 'Je m\'inscris',
            terms: 'Un e-mail à la fois, et votre adresse n\'est jamais transmise. Désinscription en un clic, dans chaque message.',
            done: {
                title: 'Consultez votre boîte mail',
                body: 'Nous vous avons envoyé un e-mail. Cliquez sur le lien pour confirmer et vous serez inscrit.',
                again: 'Inscrire une autre adresse',
            },
        },
        confirmed: {
            title: 'Inscription confirmée',
            success: 'Votre inscription est confirmée. Bienvenue !',
            body: 'Vous recevrez désormais la newsletter LatinMap : les meilleurs événements de danse latine directement dans votre boîte mail. Vous pouvez vous désinscrire en un clic depuis chaque newsletter.',
            discover_events: 'Découvrir les événements',
            back_home: 'Retour à l\'accueil',
        },
    },
    footer: {
        section_1: {
            title: 'Découvrez LatinMap',
            about: 'À propos de nous',
            how_it_works: 'Comment ça marche',
            search: 'Chercher',
            contact: 'Contact',
        },
        section_2: {
            title: 'Soutien et communauté',
            help: 'Centre d\'aide',
            privacy_policy: 'Politique de confidentialité',
            terms_and_conditions: 'Conditions générales de vente',
            cookie_policy: 'Politique relative aux cookies',
        },
        section_3: {
            title: 'Pour les professionnels',
            create_event: 'Comment créer un événement',
            create_organization: 'Comment créer une marque',
            become_ambassador: 'devenir ambassadeur',
            promote_event: 'Comment promouvoir votre événement',
            professional_account_verification: 'Vérification du compte professionnel'
        },
        section_4: {
            title: 'Catégories de danse et d\'événements',
            all_events: 'Tous les événements',
        },
        follow_our_socials: 'Suivez nos réseaux sociaux',
    }
};
